import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Line } from "react-chartjs-2";
import "chartjs-adapter-date-fns";
import DocumentsSection from "./../../Pages/Create-Investment/DocumentSection";
import { useDispatch, useSelector } from "react-redux";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { addDocumentId } from "../../Redux/store/documentSlice";
import { resetDocumentId } from "../../Redux/store/documentSlice";
import { debounce } from "lodash";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import { useToast } from "../../Utils/toastContext";
import MultiLineChart from "../../Components/MultilineChart/multiline-chart";
import { Minus, Plus } from "lucide-react";
import ReinvestProgressCard from "../../Components/progress-bar/progress-bar";
import CustomerPopup from "./customer-popup";
import {
  svgLogoBase64,
  svgBookBase64,
  svgGraphBase64,
  svgDiagramBase64,
  svgInfoCircleBase64,
  svgDollarCircleBase64,
  svgDollarSquareBase64,
  svgDollarRequestBase64,
  svgCustomerBase64,
  svgTransactionHistoryBase64,
} from "../../Constants/config";
import DownloadReportButton from "../../Components/DownloadButton/download-button";
import NoMatchSection from "../../Pages/Inspecie-Transfer/no-match-section";
import StockMatchSummary from "../../Pages/Inspecie-Transfer/stock-match-chart";
import {
  setInvestmentIDRedux,
  setTabSelfRedux,
} from "../../Redux/store/inspecie-transfer";
ChartJS.register(ArcElement, Tooltip, Legend);

const InvestmentDetailsByCustomerID = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const location = useLocation();
  const { showToast } = useToast();
  const { customerId } = useParams();
  const dispatch = useDispatch();
  const investment_id = useSelector(
    (state) => state.inspecieTransfer.investmentId
  );
  const [selectedFilter, setSelectedFilter] = useState("10Y");
  const tabSelf = useSelector((state) => state.inspecieTransfer.tabSelf);
  const [filter, setFilter] = useState(tabSelf);
  const [refId, setRefId] = useState("12345");
  const [selectedFilterHour, setSelectedFilterHour] = useState("All");
  const [strategyType, setstrategyType] = useState("test");
  const [riskProfile, setRiskProfile] = useState("60.40");
  const [investmentType, setinvestmentType] = useState("sma");
  const [performanceGraph, setPerformanceGraph] = useState([]);
  const [fundObjectives, setFundObjectives] = useState("");
  const [investments, setInvestments] = useState(["ASX ETFs", "LICs"]);
  const [growth, setGrowth] = useState(0);
  const [defensive, setDefensive] = useState(0);
  const navigate = useNavigate();
  const [investmentManagerNamefromAPI, setInvestmentManagerNamefromAPI] =
    useState("");
  const [assetManagerNamefromAPI, setAssetManagerNamefromAPI] = useState("");
  const [advisorIdfromAPI, setadvisorIdfromAPI] = useState("");
  const [subadvisorIdfromAPI, setSubadvisorIdfromAPI] = useState("");
  const [investmentProductName, setinvestmentProductName] = useState("");
  const [riskRating, setriskRating] = useState("");
  const [smaFees, setsmaFees] = useState("");
  const [assetManagerFees, setassetManagerFees] = useState("");
  const [managerFees, setmanagerFees] = useState(0);
  const [advisorFees, setadvisorFees] = useState(0);
  const [subadvisorFees, setsubadvisorFees] = useState(0);
  const [strategyDate, setstrategyDate] = useState("");
  const [minimumInvestedAmount, setminimumInvestedAmount] = useState(0);
  const [investmentManagerNameView, setinvestmentManagerNameView] = useState(0);
  const [dateCreated, setdateCreated] = useState(0);
  const [strategyTypeView, setstrategyTypeView] = useState(0);
  const [existingCategories, setExistingCategories] = useState([]);
  const [currentFunctionName, setCurrentFunctionName] = useState("");
  const [currentFunctionId, setCurrentFunctionId] = useState(null);
  const [stockPrices, setStockprices] = useState([]);
  const [combineIndex, setCombineIndex] = useState([]);
  const [isAddFundPopupOpen, setIsAddFundPopupOpen] = useState(false);
  const [totalPages, settotalPages] = useState(0);
  const [totalCount, settotalCount] = useState(0);
  const [filteredData, setfilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState(null);
  const [historyChartImage, setHistoryChartImage] = useState("");
  const [chartImage, setChartImage] = useState("");
  const reportRef = useRef();
  const chartRef = useRef(null);
  const valuationRef = useRef();
  const [isHidden, setIsHidden] = useState(false); // Initially hidden
  const historyChartRef = useRef(null);
  const [stockpricesPpdf, setStockpricesPdf] = useState([]);
  const [rawDatapdf, setRawDatapdf] = useState([]);
  const [factSheetFileName, setfactsheetFileName] = useState("");
  const [rawDatahistorypdf, setRawDatahistorypdf] = useState([]);
  const [isHiddenReport, setIsHiddenReport] = useState(false); // Initially hidden
  const [isHiddenTaxReport, setIsHiddenTaxReport] = useState(false); // Initially hidden
  const riskProfileData = [];
  const [holdingValuationData, setholdingValuationData] = useState([]);
  const [taxStatementData, setTaxStatementData] = useState([]);
  const userId = useSelector((state) => state.user.userId);
  const [transactionHistoryData, setTransactionHistoryData] = useState([]);
  const [pdfData, setPdfData] = useState([]);
  const [isHiddenTable, setIsHiddenTable] = useState(false); // Initially hidden
  const [isHiddenInvestorList, setIsHiddenInvestorList] = useState(false); // Initially hidden
  const [stockData, setStockData] = useState([]);
  const [customTime, setCustomTime] = useState(24);
  const [unmatchedStocks, setUnmatchedStocks] = useState([]);
  const [matchedStocks, setMatchedStocks] = useState([]);
  const [preSelectedBalanceChanges, setpreSelectedBalanceChanges] = useState({
    value: "All",
    label: "All Time Change",
  });
  const balanceChanges = [
    { value: "All", label: "All Time Change" },
    { value: "1Y", label: "Yearly Change" },
    { value: "1M", label: "Monthly Change" },
    { value: "1W", label: "Weekly Change" },
    // { value: "24H", label: "24H Change" },
  ];
  const [preSelectedStrategyType, setPreSelectedStrategyType] = useState(null);
  const [totalDividend, setTotalDividend] = useState(0);
  const [totalThreshold, setTotalThreshold] = useState(0);
  const [totalInvested, setTotalInvested] = useState(0);
  const [investmentList, setInvestmentList] = useState([]);
  const [totalInvestedDetails, setTotalInvestedDetails] = useState(null);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [selectedInvestmentId, setSelectedInvestmentId] = useState(null);
  const [balanceChangeFilterValue, setBalanceChangeFilterValue] =
    useState("All");
  const [balanceChangeFilterLabel, setBalanceChangeFilterLabel] = useState("");
  const [nearestStrategies, setNearestStrategies] = useState([]);
  const isMatchFoundRedux = useSelector(
    (state) => state.inspecieTransfer.isMatchFound
  );
  const [isMatchFound, setIsMatchFound] = useState(isMatchFoundRedux);
  const portfolioListRedux = useSelector(
    (state) => state.inspecieTransfer.portfolioList
  );
  const [portfolioAccounttableData, setPortfolioAccounttableData] = useState([
    portfolioListRedux,
  ]);
  const [filterText, setFilterText] = useState("created_at");
  const [isLoadingPortfolio, setIsLoadingPortfolio] = useState(false);

  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${today.getFullYear()}`;
  const optionshide = {
    cutout: "70%", // Creates the donut hole
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
  };
  const data = [
    {
      name: "Assessable Income",
      id: 1,
      total: "30,2299.0",
      items: [
        {
          name: "Interest before WHT",
          amount: "33,657.53",
          taxReturnReference: "10L",
          commentary:
            "Foreign income tax offset from distribution tax statements + foreign withholding tax on internation dividends",
        },
        {
          name: "Unfranked dividends from shares",
          amount: "33,657.53",
          taxReturnReference: "11S",
          commentary:
            "Dividends sourced from Dividends Bell Potter tab. Domestic dividends will be entities with 'LTD ORDINARY' at end of name. Unfranked/franked split is provided by franking % in column F of report. E.g. Macquarie paid $63 dividend at 40% franking - $25.20 is a franked dividend ($63*0.4), and $37.80 ($63*0.6) is an unfranked dividend. Note APA & Transurban are stapled securities so the tax statements should be looked up to see the split between dividend and distribution.",
        },
        {
          name: "Franked dividends from shares",
          amount: "33,657.53",
          taxReturnReference: "11T",
          commentary:
            "Dividends sourced from Dividends Bell Potter tab. Domestic dividends will be entities with 'LTD ORDINARY' at end of name. Unfranked/franked split is provided by franking % in column F of report. E.g. Macquarie paid $63 dividend at 40% franking - $25.20 is a franked dividend ($63*0.4), and $37.80 ($63*0.6) is an unfranked dividend. Note APA & Transurban are stapled securities so the tax statements should be looked up to see the split between dividend and distribution.",
        },
        {
          name: "Distributions from trusts",
          amount: "33,657.53",
          taxReturnReference: "13U",
          commentary:
            "Non-primary production income from trusts - sourced from individual fund tax statements",
        },
        {
          name: "Franked distributions from trusts",
          amount: "33,657.53",
          taxReturnReference: "13C",
          commentary:
            "Franked distributions - sourced from individual fund tax statements",
        },
        {
          name: "Net capital gain",
          amount: "33,657.53",
          taxReturnReference: "18A",
          commentary:
            "Capital gains from both sale of shares/units + distributions. It is important to show the gross capital gains to investors before the application of CGT discount as if they have other losses they need to apply them to the gross gain not the net gain. Additionally, ",
        },
        {
          name: "Total current year capital gains",
          amount: "33,657.53",
          taxReturnReference: "18H",
          commentary:
            "Capital gains from both sale of shares/units + distributions. It is important to show the gross capital gains to investors before the application of CGT discount as if they have other losses they need to apply them to the gross gain not the net gain. Additionally, ",
        },
        {
          name: "Foreign income",
          amount: "33,657.53",
          taxReturnReference: "20E/20M",
          commentary:
            "Foreign income from distributions + International dividends. Distribution information sourced from individiual fund tax statements. Vanguard US ETF is a dividend as it is a CDI of the ETF listed in the US so is a company not a trust.",
        },
      ],
    },
    {
      name: "Less deductions you may be entitled to",
      id: 2,
      total: "30,2299.0",
      items: [
        {
          name: "Listed investment company deductions",
          amount: "33,657.53",
          taxReturnReference: "D8H",
          commentary: "Franking credit from domestic dividends",
        },
        {
          name: "Expenses",
          amount: "33,657.53",
          taxReturnReference: "-",
          commentary: "Franking credit from domestic dividends",
        },
      ],
    },
    {
      name: "Tax offsets and credits",
      id: 3,
      total: "30,2299.0",
      items: [
        {
          name: "TFN amounts withheld from interest",
          amount: "33,657.53",
          taxReturnReference: "10M",
          commentary:
            "Relates to  from APA distribution - think of it as a return of capital - reduces cost base of units",
        },
        {
          name: "TFN amounts withheld from dividends",
          amount: "33,657.53",
          taxReturnReference: "11V",
          commentary:
            "Relates to tax deferred amount from APA distribution - think of it as a return of capital - reduces cost base of units",
        },
        {
          name: "TFN amuont withheld from trust distributions",
          amount: "33,657.53",
          taxReturnReference: "13R",
          commentary: "-",
        },
        {
          name: "Franking credits from shares (after 45 day rule)",
          amount: "33,657.53",
          taxReturnReference: "11U",
          commentary: "-",
        },
        {
          name: "Franking credits from trust distributions (after 45 day rule)",
          amount: "33,657.53",
          taxReturnReference: "13Q",
          commentary: "-",
        },
        {
          name: "Foreign income tax offset",
          amount: "33,657.53",
          taxReturnReference: "20O",
          commentary: "-",
        },
        {
          name: "Early Stage Venture Capital Limited Partnership (ESVCLP) Tax Offset",
          amount: "33,657.53",
          taxReturnReference: "T7K",
          commentary: "-",
        },
      ],
    },
    {
      name: "Non-assessable amounts",
      id: 4,
      total: "30,2299.0",
      items: [
        {
          name: "Net exempt income",
          amount: "33,657.53",
          taxReturnReference: "-",
          commentary: "-",
        },
        {
          name: "Non-assessable non exempt amount",
          amount: "33,657.53",
          taxReturnReference: "-",
          commentary: "-",
        },
        {
          name: "Tax deferred amount",
          amount: "33,657.53",
          taxReturnReference: "-",
          commentary: "-",
        },
        {
          name: "Tax deferred amount",
          amount: "33,657.53",
          taxReturnReference: "-",
          commentary: "-",
        },
        {
          name: "Other non-attributable amounts",
          amount: "33,657.53",
          taxReturnReference: "-",
          commentary: "-",
        },
        {
          name: "Return of capital ",
          amount: "33,657.53",
          taxReturnReference: "-",
          commentary: "-",
        },
      ],
    },
  ];
  const capitalGainData = {
    totalQuantity: 1000,
    totalSales: 1000,
    totalAquisitionCost: 1000,
    totalTaxAdjustedCost: 1000,
    totalCapitalLoss: 1000,
    totalGainWithoutDiscount: 1000,
    totalGainWithDiscount: 1000,
    data: [
      {
        name: "THE A2 MILK COMPANY ORDINARY",
        id: 1,
        totalQuantity: "1000",
        totalSaleProceeds: "12,889.00",
        totalTaxAdjustedCost: "33,555.00",
        totalCapitalLoses: "33,555.00",
        totalCapitalGainWithoutDiscount: "33,555.00",
        items: [
          {
            dateOfDisposal: "28/12/2024",
            quantity: "1000",
            saleProceeds: "12,889.00",
            dateOfAcquisition: "02/11/2021",
            taxAdjustedCost: "33,555.00",
            capitalLoses: "33,555.00",
            capitalGainWithoutDiscount: "33,555.00",
          },
          {
            dateOfDisposal: "28/12/2024",
            quantity: "1000",
            saleProceeds: "12,889.00",
            dateOfAcquisition: "02/11/2021",
            taxAdjustedCost: "33,555.00",
            capitalLoses: "33,555.00",
            capitalGainWithoutDiscount: "33,555.00",
          },
        ],
      },
      {
        name: "ALS LTD ORDINARY",
        id: 2,
        totalQuantity: "1000",
        totalSaleProceeds: "12,889.00",
        totalTaxAdjustedCost: "33,555.00",
        totalCapitalLoses: "33,555.00",
        totalCapitalGainWithoutDiscount: "33,555.00",
        items: [
          {
            dateOfDisposal: "28/12/2024",
            quantity: "1000",
            saleProceeds: "12,889.00",
            dateOfAcquisition: "02/11/2021",
            taxAdjustedCost: "33,555.00",
            capitalLoses: "33,555.00",
            capitalGainWithoutDiscount: "33,555.00",
          },
          {
            dateOfDisposal: "28/12/2024",
            quantity: "1000",
            saleProceeds: "12,889.00",
            dateOfAcquisition: "02/11/2021",
            taxAdjustedCost: "33,555.00",
            capitalLoses: "33,555.00",
            capitalGainWithoutDiscount: "33,555.00",
          },
        ],
      },
    ],
  };
  const trustData = [
    {
      label: "Distribution before WHT",
      total: 2428.94,
      data: [
        {
          label: "Capital Gains",
          categories: [
            { name: "Gains not eligible for discount (TARP)", amount: 0.0 },
            { name: "Gains not eligible for discount (NTARP)", amount: 0.0 },
            { name: "Discounted capital gains (TARP)", amount: 34.92 },
            { name: "Discounted capital gains (NTARP)", amount: 54.79 },
            { name: "AMIT CGT Gross up amount", amount: 89.71 },
          ],
        },
        {
          label: "Assessable Foreign Income",
          categories: [
            { name: "Foreign trust and CFC income", amount: 0.0 },
            { name: "Foreign income", amount: 15898.15 },
          ],
        },
        {
          label: "Non Assessable Amount",
          categories: [
            { name: "CGT concession", amount: 0.0 },
            { name: "Tax free income", amount: 0.0 },
            { name: "Tax deferred income", amount: 23.0 },
            { name: "NANE Income", amount: 1.1 },
            { name: "AMIT cost base adjustment", amount: 157.89 },
          ],
        },

        {
          label: "Less tax offsets and credits",
          categories: [
            { name: "CGT concession", amount: 0.0 },
            { name: "Tax free income", amount: 0.0 },
            { name: "Tax deferred income", amount: 23.0 },
            { name: "NANE Income", amount: 1.1 },
            { name: "AMIT cost base adjustment", amount: 157.89 },
          ],
        },
      ],
    },
    {
      label: "Distribution after WHT",
      total: 0.0,
      data: [
        {
          label: "Less withholding taxes",
          categories: [
            { name: "Non-resident WHT on interest", amount: 0.0 },
            { name: "Non-resident WHT on unfranked divs", amount: 0.0 },
            { name: "Non-resident WHT on MIT trust dist", amount: 0.0 },
            { name: "Non-resident WHT on other comp", amount: 0.0 },
            { name: "TFN tax withheld", amount: 0.0 },
          ],
        },
      ],
    },
  ];
  const portfolioAccountheaders = [
    { label: "Investment ID", key: "investment ID" },
    { label: "Investment Product Name", key: "productName" },
    { label: "Matched %", key: "Matched" },
    { label: "Minimum Investment Amount", key: "Matched" },
  ];
  const handleSort = (key) => {
    setFilterText(key);
  };
  const handleshowRecord = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecordsStrategies(parseInt(selectedOption.value));
    setCurrentPageStrategies(1);
  };
  const handleBalanceChangesChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setBalanceChangeFilterValue(selectedOption.value);
    setSelectedFilterHour(selectedOption.value);
    setBalanceChangeFilterLabel(selectedOption.label);
  };
  function renderStrategyLayout(data) {
    const categoryColors = [
      "from-blue-300 to-blue-500",
      "from-green-300 to-green-500",
      "from-purple-300 to-purple-500",
      "from-yellow-300 to-yellow-500",
      "from-pink-300 to-pink-500",
      "from-orange-300 to-orange-500",
    ];

    const container = document.createElement("div");
    container.className = "pt-4";

    data.forEach((category, index) => {
      const strategySection = document.createElement("div");
      strategySection.className = `
  strategy-section rounded-xl shadow-md border border-gray-500 bg-white 
  break-inside-avoid p-2
`;

      if (index === 0) {
        strategySection.classList.add("mt-0");
      } else {
        strategySection.classList.add("mt-6");
      }

      const strategyTitle = document.createElement("div");
      const gradientClass = categoryColors[index % categoryColors.length];
      strategyTitle.className = `
      text-md font-bold px-4 py-3 rounded-t-xl 
      bg-gradient-to-r ${gradientClass} text-black
    `;
      strategyTitle.textContent = category.name.toUpperCase();
      strategySection.appendChild(strategyTitle);

      const totalBlock = document.createElement("div");
      totalBlock.className = `
      text-right text-sm px-4 pt-2 text-gray-800 italic 
      border-b border-black pb-2
    `;
      totalBlock.textContent = `Total: $${category.total}`;
      strategySection.appendChild(totalBlock);

      const tableWrapper = document.createElement("div");
      tableWrapper.className = "overflow-x-auto px-4";

      const table = document.createElement("table");
      table.className = `
      w-full text-xs mt-2 table-auto border-collapse 
    `;

      // Table header
      const thead = document.createElement("thead");
      thead.innerHTML = `
      <tr class="bg-gray-100 text-black font-semibold">
        <th class="text-left px-3 py-2  rounded-l-xl whitespace-nowrap">Item Name</th>
        <th class="text-left px-3 py-2 whitespace-nowrap">Amount</th>
        <th class="text-left px-3 py-2  whitespace-nowrap">Tax Return Ref</th>
        <th class="text-left px-3 py-2 rounded-r-xl whitespace-nowrap">Commentary</th>
      </tr>
    `;
      thead.style.display = "table-header-group"; // Repeats header on page break
      table.appendChild(thead);

      const tbody = document.createElement("tbody");
      category.items.forEach((item, i) => {
        const row = document.createElement("tr");
        row.className = i % 2 === 0 ? "bg-white" : "bg-gray-50"; // Zebra striping
        row.style.breakInside = "avoid";

        row.innerHTML = `
        <td class="py-2 px-3 text-gray-800  whitespace-nowrap">${item.name}</td>
        <td class="py-2 px-3 text-gray-800   whitespace-nowrap">$${item.amount}</td>
        <td class="py-2 px-3 text-gray-800 whitespace-nowrap">${item.taxReturnReference}</td>
<td class="py-2 px-3 text-gray-800  whitespace-normal break-words">${item.commentary}</td>
      `;
        tbody.appendChild(row);
      });

      table.appendChild(tbody);
      tableWrapper.appendChild(table);
      strategySection.appendChild(tableWrapper);
      container.appendChild(strategySection);
    });

    return container;
  }
  function renderSubtotalRow(entry) {
    return `
    <tr class="subtotal-row" aria-label="Subtotal for ${entry.name}">
      <td class="subtotal-label" colspan="1">Subtotal</td>
      <td>${entry.totalQuantity}</td>
      <td>$${entry.totalSaleProceeds}</td>
      <td>$${entry.totalTaxAdjustedCost}</td>
      <td class="subtotal-loss">$${entry.totalCapitalLoses}</td>
      <td class="subtotal-gain">$${entry.totalCapitalGainWithoutDiscount}</td>
    </tr>
  `;
  }

  // Function to generate a visually appealing PDF-friendly capital gains layout
  function renderCapitalGainLayout(capitalGainData) {
    const container = document.createElement("div");

    const style = `
    <style>
      body {
        font-family: 'Segoe UI', Tahoma, sans-serif;
        color: #374151;
        background: #ffffff; /* Pure white for PDF */
      }

      .section-title-summary {
        font-size: 14px;
        font-weight: 500;
        color: #1f2937;
        margin: 0 0 10px;
        border-left: 5px solid #6366f1; /* Indigo-500 */
        padding-left: 12px;
      }

      .summary-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        margin-bottom: 24px;
        background: #ffffff;
        padding: 16px;
        border: 1px solid #6b7280	;
        border-radius: 10px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.05);
      }

      .summary-cell {
        flex: 1 1 260px;
        background: #f9fafb;
        border-left: 6px solid #10b981; /* Emerald-500 */
        padding: 14px 16px;
        border-radius: 8px;
        box-shadow: 0 1px 2px rgba(0,0,0,0.04);
        transition: background-color 0.3s ease;
        font-size: 12px;
        color: #4b5563;
      }

      .summary-cell:hover {
        background-color: #d1fae5;
      }

      .summary-cell strong {
        color: #111827;
        font-weight: 600;
      }

      .capital-gain-table {
        width: 100%;
     border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 24px;
  font-size: 12px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 6px rgb(0 0 0 / 0.05);

      }

      .capital-gain-table th {
        background-color: #eef2ff; /* Indigo-100 */
        color: #3730a3; /* Indigo-700 */
        padding: 8px 10px;
        text-align: left;
        border: 1px solid #d1d5db;
        font-weight: 700;
        user-select: none;
      }
        .capital-gain-table thead tr:first-child th:first-child {
  border-top-left-radius: 10px;
}
.capital-gain-table thead tr:first-child th:last-child {
  border-top-right-radius: 10px;
}
.capital-gain-table tfoot tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}
.capital-gain-table tfoot tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

      .capital-gain-table td {
        padding: 8px 10px;
        border: 1px solid #e5e7eb;
        background: #ffffff;
        color: #374151;
      }

      .capital-gain-table tr:nth-child(even) td {
        background-color: #f9fafb;
      }

      .capital-gain-table tr:hover td {
        background-color: #d1fae5;
        cursor: default;
      }

      .capital-gain-table tfoot tr {
        background-color: #e0e7ff; /* Indigo-200 */
        font-weight: 700;
      }

      .gain {
        color: #047857; /* Emerald-700 */
        font-weight: 600;
      }

      .loss {
        color: #b91c1c; /* Red-700 */
        font-weight: 600;
      }

       .badge {
        font-size: 11px;
        font-weight: 600;
        background: #dbeafe;
        color: #1d4ed8;
        border-radius: 9999px;
        padding: 2px 8px;
        margin-top: 6px;
        display: inline-block;
      }

      .badge-green {
        background: #d1fae5;
        color: #065f46;
          font-size: 11px;
        font-weight: 600;
        border-radius: 9999px;
        padding: 2px 8px;
        margin-top: 6px;
        display: inline-block;
      }

      .badge-red {
        background: #fee2e2;
        color: #b91c1c;
          font-size: 11px;
        font-weight: 600;
        border-radius: 9999px;
        padding: 2px 8px;
        margin-top: 6px;
        display: inline-block;
      }
    </style>
  `;

    container.innerHTML += style;

    // Summary Section
    const summaryHTML = `
  <div class="section-title-summary">Capital Gains Summary</div>
  <div class="summary-grid" role="region" aria-label="Capital Gains Summary">
    <div class="summary-cell" tabindex="0">
      <p><strong>Capital gains/loss on sales:</strong></p>
      <p><span class="badge-red">($13,158.72)</span> / <span class="badge-green">$39,720.71</span></p>
    </div>
    <div class="summary-cell" tabindex="0">
      <p><strong>Capital gains from distributions:</strong></p>
      <p class=""><strong>TARP:</strong> <p class=" badge"> $69.84</p></p>
      <p class=""></strong>Non-TARP:</strong> <p class=" badge"> $109.58</p></p>
    </div>
    <div class="summary-cell" tabindex="0">
      <p><strong>Subtotal before losses:</strong><p class="badge"> $179.42</p></p>
      <p><strong>Total:</strong><p class="badge"> $39,720.71</p></p>
    </div>
    <div class="summary-cell" tabindex="0">
      <p><strong>Application of losses:</strong></p>
      <p>Applied: <span class="badge-red">$13,158.72</span></p>
      <p>Remaining: <strong>-</strong></p>
    </div>
    <div class="summary-cell" tabindex="0">
      <p><strong>Subtotal after losses:</strong><p class="badge"> $26,561.99</p></p>
    </div>
    <div class="summary-cell" tabindex="0">
      <p><strong>CGT Discount:</strong> <span class="badge">($59.81)</span></p>
    </div>
    <div class="summary-cell" tabindex="0">
      <p><strong>Net Capital Gains/Loss:</strong></p>
      <p>Not eligible for discount: <p class="badge">$26,561.99</p></p>
      <p>Eligible for discount:<p class="badge">$119.61</p></p>
    </div>
  </div>
`;

    container.innerHTML += summaryHTML;

    // Company Detail Sections
    capitalGainData.data.forEach((entry) => {
      // Calculate subtotals for detailed transactions
      const subtotal = entry.items.reduce(
        (acc, item) => {
          acc.quantity += Number(item.quantity);
          acc.saleProceeds += Number(item.saleProceeds);
          acc.taxAdjustedCost += Number(item.taxAdjustedCost);
          acc.capitalLosses += Number(item.capitalLosses);
          acc.capitalGainWithoutDiscount += Number(
            item.capitalGainWithoutDiscount
          );
          return acc;
        },
        {
          quantity: 0,
          saleProceeds: 0,
          taxAdjustedCost: 0,
          capitalLosses: 0,
          capitalGainWithoutDiscount: 0,
        }
      );

      const companyHTML = `
      <div class="section-title-summary">${entry.name}</div>
      <table class="capital-gain-table" role="table" aria-label="Detailed transactions for ${
        entry.name
      }">
        <thead>
          <tr>
            <th scope="col">Disposed</th>
            <th scope="col">Qty</th>
            <th scope="col">Sale Proceeds</th>
            <th scope="col">Acquired</th>
            <th scope="col">Adjusted Cost</th>
            <th scope="col">Loss</th>
            <th scope="col">Gain</th>
          </tr>
        </thead>
        <tbody>
          ${entry.items
            .map(
              (item) => `
              <tr>
                <td>${item.dateOfDisposal}</td>
                <td>${item.quantity}</td>
                <td>$${item.saleProceeds}</td>
                <td>${item.dateOfAcquisition}</td>
                <td>$${item.taxAdjustedCost}</td>
             <td><span class="loss">($123.45)</span></td>
<td><span class="gain">$567.89</span></td>

              </tr>`
            )
            .join("")}
        </tbody>
 <tfoot>
  <tr>
    <td><strong>Subtotal</strong></td>
    <td><strong>${subtotal.quantity}</strong></td>
    <td><strong>$${subtotal.saleProceeds.toFixed(2)}</strong></td>
    <td></td>
    <td><strong>$${subtotal.taxAdjustedCost.toFixed(2)}</strong></td>
   <td><span class="loss">($123.45)</span></td>
<td><span class="gain">$567.89</span></td>

  </tr>
</tfoot>

      </table>
    `;

      container.innerHTML += companyHTML;
    });

    return container;
  }
  function getCoordinatesForPercent(percent) {
    const x = Math.cos(2 * Math.PI * percent) * 100 + 100;
    const y = Math.sin(2 * Math.PI * percent) * 100 + 100;
    return [x, y];
  }

  function getColor(index) {
    const colors = [
      "#60a5fa", // blue-400
      "#34d399", // green-400
      "#fbbf24", // yellow-400
      "#f87171", // red-400
      "#a78bfa", // purple-400
      "#38bdf8", // sky-400
      "#f472b6", // pink-400
    ];
    return colors[index % colors.length];
  }
  function generatePieChartBase64(chartData) {
    return new Promise((resolve) => {
      const canvas = document.createElement("canvas");
      canvas.width = 300;
      canvas.height = 300;
      const ctx = canvas.getContext("2d");

      new ChartJS(ctx, {
        type: "pie",
        data: {
          labels: chartData.map((d) => d.label),
          datasets: [
            {
              data: chartData.map((d) => d.amount),
              backgroundColor: chartData.map((d) => d.color), // use mapped colors
              borderWidth: 1,
            },
          ],
        },

        options: {
          responsive: false,
          animation: {
            onComplete: () => {
              resolve(canvas.toDataURL("image/png"));
            },
          },
          plugins: {
            legend: { display: false },
            tooltip: { enabled: false },
          },
        },
      });
    });
  }

  async function renderTrustDistributionLayout(trustData) {
    const getColor = (i) => {
      const colors = [
        "#6AA7D3",
        "#F4D580",
        "#C0E2C1",
        "#E6B8AF",
        "#92C5EA",
        "#FFABAB",
        "#BFA9F2",
        "#F3A9A9",
        "#AED581",
        "#90CAF9",
      ];
      return colors[i % colors.length];
    };

    // Flatten and compute top-level group totals
    const pieColors = [
      "#1f77b4", // dark blue
      "#ff7f0e", // orange
      "#2ca02c", // green
      "#d62728", // red
      "#9467bd", // purple
      "#8c564b", // brown
      "#e377c2", // pink
      "#7f7f7f", // gray
      "#bcbd22", // olive
      "#17becf", // teal
    ];

    const categoryColorMap = {};
    let colorIndex = 0;

    const chartData = trustData.flatMap((group) =>
      group.data.flatMap((section) =>
        section.categories
          .filter((cat) => cat.amount > 0)
          .map((cat) => {
            if (!categoryColorMap[cat.name]) {
              categoryColorMap[cat.name] =
                pieColors[colorIndex % pieColors.length];
              colorIndex++;
            }
            return {
              label: cat.name,
              amount: cat.amount,
              color: categoryColorMap[cat.name],
            };
          })
      )
    );

    const overallTotal = chartData.reduce((sum, d) => sum + d.amount, 0);

    // Build legend and table rows
    const groupBaseColors = ["#1f77b4", "#f4c542"]; // blue, yellow

    const legendHTML = trustData
      .map((group, groupIndex) => {
        const sections = group.data || [];
        const groupColor = groupBaseColors[groupIndex % groupBaseColors.length]; // <<< ADD THIS LINE

        const sectionBreakdown = sections
          .map((section) => {
            const categoryList = section.categories
              .filter((cat) => cat.amount > 0)
              .map((cat) => {
                const color = categoryColorMap[cat.name] || "#ccc";
                return `<li style="list-style-type: none; display: flex; align-items: center; gap: 6px; margin-bottom: 2px;">
          <div style="width:10px; height:10px; background-color:${color}; border-radius:2px;"></div>
          <span>${cat.name} - $${cat.amount.toLocaleString()}</span>
        </li>`;
              })
              .join("");

            return `
      <div style="margin-top: 8px;">
        <div style="font-weight: 600; font-size: 13px; margin-bottom: 4px;">${section.label}</div>
        <ul style="margin-left: 20px; font-size: 12px; color: #444;">
          ${categoryList}
        </ul>
      </div>
    `;
          })
          .join("");

        const groupTotal = group.total?.toFixed(2) ?? "0.00";
        const percent = overallTotal
          ? ((group.total / overallTotal) * 100).toFixed(1)
          : 0;

        return `
    <div style="margin-bottom: 16px;">
      <div style="display: flex; align-items: center; gap: 8px; font-weight: bold; font-size: 14px;">
        <div style="width: 12px; height: 12px; background-color: ${groupColor}; border-radius: 2px;"></div>
        ${group.label} — ${percent}%
      </div>
      ${sectionBreakdown}
    </div>
  `;
      })
      .join("");

    const chart = await generatePieChartBase64(chartData);

    const wrapper = document.createElement("div");
    wrapper.innerHTML = `
    <div class="pdf-container">
      <div class="header">
        <div class="title-section">
          <svg class="icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20" height="20">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 3v10h10A10 10 0 0011 3z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13A9 9 0 113 11h8V3a9 9 0 0110 10z" />
          </svg>
          <h2 class="second-title">Distributions</h2>
        </div>
      </div>

      <div style="display: flex; gap: 40px; align-items: flex-start;">
        <div style="flex: 1;">${legendHTML}</div>
        <div class="chart-container">
          <img src="${chart}" alt="Trust Pie Chart" />
        </div>
      </div>
    </div>
  `;

    return wrapper;
  }

  function renderGenericSummaryAndTableLayout({
    title,
    summaryData,
    tableData,
    columns,
    subtotals = {},
  }) {
    const container = document.createElement("div");

    const style = `
   <style>
  body {
    font-family: 'Segoe UI', Tahoma, sans-serif;
    color: #374151;
    background: #ffffff;
    font-size: 10px;
  }

  .section-title-summary {
    font-size: 12px;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 8px;
    border-left: 4px solid #6366f1;
    padding-left: 10px;
  }

  .summary-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;
    padding: 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    background: #f9fafb;
  }

  .summary-cell {
    flex: 1 1 200px;
    background: #ffffff;
    border-left: 4px solid #10b981;
    padding: 10px;
    border-radius: 6px;
    font-size: 9px;
  }

  .summary-cell strong {
    display: block;
    font-weight: 600;
    margin-bottom: 4px;
    color: #111827;
  }

  .badge {
    display: inline-block;
    background: #dbeafe;
    color: #1d4ed8;
    border-radius: 9999px;
    padding: 2px 6px;
    font-size: 9px;
    font-weight: 600;
  }

  table.capital-gain-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 9px;
    margin-bottom: 20px;
  }

  .capital-gain-table th,
  .capital-gain-table td {
    padding: 4px 6px;
    border: 1px solid #d1d5db;
    text-align: left;
    vertical-align: top;
    word-break: break-word;
  }

  .capital-gain-table thead {
    background-color: #f3f4f6;
  }

  .capital-gain-table tbody tr:nth-child(odd) {
    background-color: #f9fafb;
  }

  .capital-gain-table tfoot {
    background-color: #f3f4f6;
    font-weight: bold;
  }
</style>
  `;

    container.innerHTML += style;

    // Add summary section
    const summaryHTML = `
    <div class="section-title-summary">${title} Summary</div>
    <div class="summary-grid" role="region" aria-label="${title} Summary">
      ${Object.entries(summaryData)
        .map(
          ([key, value]) => `
          <div class="summary-cell">
            <strong>${key}</strong>
            <div class="badge">$${value.toLocaleString()}</div>
          </div>
        `
        )
        .join("")}
    </div>
  `;
    container.innerHTML += summaryHTML;

    // Render each table group
    tableData.forEach((entry) => {
      const tableHTML = `
      <div class="section-title-summary">${entry.name}</div>
      <table class="capital-gain-table" role="table" aria-label="Details for ${
        entry.name
      }">
        <thead>
          <tr>
            ${columns.map((col) => `<th>${col.label}</th>`).join("")}
          </tr>
        </thead>
        <tbody>
          ${entry.items
            .map(
              (item) => `
            <tr>
              ${columns
                .map((col) => `<td>${item[col.key] ?? "-"}</td>`)
                .join("")}
            </tr>
          `
            )
            .join("")}
        </tbody>
        ${
          Object.keys(subtotals).length
            ? `
          <tfoot>
            <tr>
              ${columns
                .map((col, i) => {
                  const subtotalKey = subtotals[col.key];
                  return subtotalKey
                    ? `<td>${entry[subtotalKey]}</td>`
                    : i === 0
                    ? `<td><strong>Subtotal</strong></td>`
                    : `<td>-</td>`;
                })
                .join("")}
            </tr>
          </tfoot>
        `
            : ""
        }
      </table>
    `;

      container.innerHTML += tableHTML;
    });

    return container;
  }

  const dataset = {
    labels: rawDatapdf.map((item) => item.product.name), // Extract names
    datasets: [
      {
        data: rawDatapdf.map((item) => parseFloat(item.allocation)), // Convert allocation to numbers
        backgroundColor: rawDatapdf.map((item) => `#${item.product.color}`), // Ensure # prefix
        hoverBackgroundColor: rawDatapdf.map(
          (item) => `#${item.product.color}`
        ), // Same for hover
        borderWidth: 1,
      },
    ],
  };
  useEffect(() => {
    if (chartRef.current && dataset?.datasets?.length > 0) {
      setTimeout(() => {
        const chartInstance = chartRef.current;
        if (chartInstance?.toBase64Image) {
          setChartImage(chartInstance.toBase64Image());
        }
      }, 1000); // Ensures the chart fully renders before conversion
    }
  }, [dataset]);
  riskProfileData.push({
    value: 1,
    label: "BUY",
  });
  const quickFilters = [
    { label: "This Week", value: "this_week" },
    { label: "Last Week", value: "last_week" },
    { label: "This Month", value: "this_month" },
    { label: "This Year", value: "this_year" },
    { label: "Last Year", value: "last_year" },
    { label: "Custom", value: "custom" },
    { label: "All Time", value: "" },
  ];
  const secondheaders = [
    "Investment Manager",
    "Date",
    "Strategy",
    "Growth",
    "Defensive",
  ];
  const [preSelectedInvestmentFilter, setpreSelectedInvestmentFilter] =
    useState({});
  const [showRecords, setShowRecords] = useState(10);
  const [showRecordsStrategies, setShowRecordsStrategies] = useState(10);
  const [currentPageStrategies, setCurrentPageStrategies] = useState(1);
  const [totalCountStrategies, setTotalCountStrategies] = useState(0);
  const [totalPageStrategies, setTotalPageStrategiesStrategies] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRange, setSelectedRange] = useState("Select Date Range");
  const [selectedDates, setSelectedDates] = useState([]);
  const [quickFilter, setQuickFilter] = useState("");

  const [pastPerformance, setpastPerformance] = useState("");
  const [disclaimer, setDisclaimer] = useState("");
  const [copyright, setCopyright] = useState("");
  const [allocationGraphData, setfilteredGraphdata] = useState([]);
  const [rawData, setrawData] = useState([]);
  const [investmentId, setInvestmentId] = useState(investment_id);
  const [manageFundData, setManageFundData] = useState(null);
  const [isLoadingGraph, setIsLoadingGraph] = useState(false);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const DateCalendarRef = useRef();
  const DownloadRef = useRef();

  const [isLoading, setIsLoading] = useState(false);

  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 10,
    label: "10",
  });
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);

  const filterOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ];
  const investorListData = [
    {
      investorName: "Trustee For INDO SF",
      dateInvested: "01/04/2022",
      investmentAmount: "1000",
      principlePaid: "1000",
      maturityDate: "01/04/2022",
    },
    {
      investorName: "B. Moses Holdings",
      dateInvested: "01/04/2022",
      investmentAmount: "1000",
      principlePaid: "1000",
      maturityDate: "01/04/2022",
    },
  ];
  const couponListData = [
    {
      description: "Trustee For INDO SF",
      dueDate: "01/04/2022",
      couponAmount: "1000",
      paid: "1000",
      balance: "0",
    },
    {
      description: "Trustee For INDO SF",
      dueDate: "01/04/2022",
      couponAmount: "1000",
      paid: "1000",
      balance: "0",
    },
  ];
  const handleUserClick = (funcName, funcId) => {
    setCurrentFunctionName(funcName);
    setCurrentFunctionId(funcId);
    setIsAddFundPopupOpen(true);
  };
  const handleFilterChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);

  const handleInvestmentFilterChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setInvestmentId(selectedOption.value);
    setpreSelectedInvestmentFilter({
      value: selectedOption.value,
      label: selectedOption.label,
    });
    setSearchQuery("");
    setShowRecords(10);
    setSelectedDates([]);
    setSelectedRange("Select Date Range");
    setSelectedFilterHour("All");
    setBalanceChangeFilterValue("All");
    setpreSelectedBalanceChanges({ value: "All", label: "All Time Change" });
    dispatch(setInvestmentIDRedux(selectedOption.value));
  };

  const [investmentportfolioData, setInvestmentPortfolioData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Download Report");
  // Download factsheet code
  const downloadPDF = useCallback(
    debounce(() => {
      setIsHidden(true);
    }, 1000), // Debounce time
    [factSheetFileName] // Dependencies
  );

  function generateAllocationItems(details) {
    return details.product_allocations
      .map((item) => {
        return `
          <div class="allocation-item">
            <span class="label">${item.product.name}</span>
            <span class="percentage" style="color: #${item.product.color};">
              ${item.allocation}%
            </span>
          </div>
        `;
      })
      .join("");
  }
  function populateTableHolding(data) {
    const tableBody = document.createElement("tbody");

    if (data.length > 0) {
      data.forEach((categoryData) => {
        // Create category row
        const categoryRow = document.createElement("tr");
        if (categoryData.name.toUpperCase() == "GROWTH") {
          categoryRow.classList.add("bg-light-blue", "text-bold");
        } else {
          categoryRow.classList.add("bg-light-green", "text-bold");
        }
        categoryRow.innerHTML = `
                  <td colspan="1"></td>
            <td colspan="1">${categoryData.name.toUpperCase()}</td>
                              <td colspan="1"></td>
                  <td colspan="1"></td>
                  <td colspan="1"></td>
    <td colspan="1" class=""></td>
                <td colspan="1" class=""></td>
                                  <td colspan="1"></td>
                  <td colspan="1"></td>
                                    <td colspan="1"></td>
                                                                        <td colspan="1"></td>



        `;
        tableBody.appendChild(categoryRow);

        // Loop through each product in the category
        categoryData.products.forEach((product, productIndex) => {
          const productRow = document.createElement("tr");
          if (categoryData.name.toUpperCase() == "GROWTH") {
            productRow.classList.add("bg-product-blue", "text-product");
          } else {
            productRow.classList.add("bg-product-green", "text-product");
          }
          productRow.innerHTML = `
                <td>${(productIndex + 1).toString().padStart(2, "0")}</td>
                <td>${product.name}</td>
                <td></td>
                <td></td>
                <td></td>
                <td class="text-right">${product.current_value
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                <td class="text-right">${product.current_percentage.toFixed(
                  2
                )}%</</td>
                <td></td>
                                <td class="text-right">${product.target_value
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                                <td class="t">${product.difference_percentage.toFixed(
                                                  2
                                                )}</td>
                                                                                                <td class="">${product.target_percentage.toFixed(
                                                                                                  2
                                                                                                )}%</td>



            `;
          tableBody.appendChild(productRow);

          // Loop through each stock in the product
          product.stocks.forEach((stock) => {
            const stockRow = document.createElement("tr");
            if (categoryData.name.toUpperCase() == "GROWTH") {
              stockRow.classList.add("bg-stock-blue");
            } else {
              stockRow.classList.add("bg-stock-green");
            }
            stockRow.innerHTML = `
                    <td></td>
                    <td>${stock.name}</td>
                    <td>${stock.code}</td>
                    <td class="">${stock.holdings_quantity
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    ${!stock.holdings_quantity ? "-" : ""}</td>
                    <td class="">${
                      stock.cost_base
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                    }</td>
                    <td class=" text-right">${stock.value
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                    <td class=" text-right">${stock.target_weight.toFixed(
                      2
                    )}%</td>
                                                 <td class="text-right">${
                                                   stock.market_price
                                                     .toFixed(2)
                                                     .toString()
                                                     .replace(
                                                       /\B(?=(\d{3})+(?!\d))/g,
                                                       ","
                                                     ) || "-"
                                                 }</td>
                    <td class="text-right">${stock.value
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                    <td class="">${
                                      stock.profit_loss
                                        .toFixed(2)
                                        .toString()
                                        .replace(
                                          /\B(?=(\d{3})+(?!\d))/g,
                                          ","
                                        ) || "-"
                                    }</td>
                                                                                    <td class="">
                                                                                    ${stock.current_weight.toFixed(
                                                                                      2
                                                                                    )}%</td>


                `;
            tableBody.appendChild(stockRow);
          });
        });
        const subTotalRow = document.createElement("tr");
        if (categoryData.name.toUpperCase() == "GROWTH") {
          subTotalRow.classList.add("bg-light-blue", "text-bold");
        } else {
          subTotalRow.classList.add("bg-light-green", "text-bold");
        }
        subTotalRow.innerHTML = `
                    <td class=""></td>
              <td colspan="1">SUB-TOTAL ${categoryData.name}</td>
              <td></td>
              <td></td>
              <td class=""></td>
              <td class="">${categoryData.current_value
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
              <td class="text-right">${categoryData.current_percentage.toFixed(
                2
              )}%</td>
                                                <td class=""></td>
                                                                <td class="">${categoryData.target_value
                                                                  .toFixed(2)
                                                                  .toString()
                                                                  .replace(
                                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                                    ","
                                                                  )}</td>
                                                <td class="">${categoryData.difference_percentage.toFixed(
                                                  2
                                                )}</td>
                                                                                                <td class="">${categoryData.target_percentage.toFixed(
                                                                                                  2
                                                                                                )}%</td>



          `;
        tableBody.appendChild(subTotalRow);
      });
      const summaryHeadingRow = document.createElement("tr");
      summaryHeadingRow.classList.add("bg-summary", "text-bold");
      summaryHeadingRow.innerHTML = `
                  <td class=""></td>
            <td colspan="1">Summary</td>
                    <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                                  <td class=""></td>
                                                <td class=""></td>
                                                                                                <td class=""></td>



        `;
      tableBody.appendChild(summaryHeadingRow);
      const summaryGrowthRow = document.createElement("tr");
      summaryGrowthRow.classList.add("bg-light-blue", "text-bold");
      summaryGrowthRow.innerHTML = `
                  <td class=""></td>
            <td colspan="1">${data[0].name}</td>
                    <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class="">${data[0].current_value
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                  <td class="">${data[0].current_percentage.toFixed(2)}%</td>
                  <td class=""></td>
                                  <td class="">${data[0].target_value
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                                <td class="">${data[0].difference_percentage.toFixed(
                                                  2
                                                )}</td>
                                                                                                <td class="">${data[0].target_percentage.toFixed(
                                                                                                  2
                                                                                                )}%</td>



        `;
      tableBody.appendChild(summaryGrowthRow);
      const summaryDefensiveRow = document.createElement("tr");
      summaryDefensiveRow.classList.add("bg-light-green", "text-bold");
      summaryDefensiveRow.innerHTML = `
                  <td class=""></td>
            <td colspan="1">${data[1].name}</td>
                    <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class="">${data[1].current_value
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                  <td class="">${data[1].current_percentage.toFixed(2)}%</td>
                  <td class=""></td>
                                  <td class="">${data[1].target_value
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                                <td class="">${data[1].difference_percentage.toFixed(
                                                  2
                                                )}</td>
                                                                                                <td class="">${data[1].target_percentage.toFixed(
                                                                                                  2
                                                                                                )}%</td>



        `;
      tableBody.appendChild(summaryDefensiveRow);
      const summaryTotalRow = document.createElement("tr");
      summaryTotalRow.classList.add("bg-summary", "text-bold");
      summaryTotalRow.innerHTML = `
                             <td class=""></td>
            <td colspan="1">TOTAL PORTFOLIO</td>
                    <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class="">${(data[0].current_value + data[1].current_value)
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                  <td class="">${(
                    data[0].current_percentage + data[1].current_percentage
                  ).toFixed(2)}%</td>
                  <td class=""></td>
                                  <td class="">${(
                                    data[0].target_value + data[1].target_value
                                  )
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                                <td class="">${(
                                                  data[0]
                                                    .difference_percentage +
                                                  data[1].difference_percentage
                                                ).toFixed(2)}</td>
                                                                                                <td class="">${(
                                                                                                  data[0]
                                                                                                    .target_percentage +
                                                                                                  data[1]
                                                                                                    .target_percentage
                                                                                                ).toFixed(
                                                                                                  2
                                                                                                )}%</td>



        `;
      tableBody.appendChild(summaryTotalRow);
      return tableBody;
    } else {
      // ✅ Handle undefined, null, or empty data
      if (!Array.isArray(data) || data.length === 0) {
        const emptyRow = document.createElement("tr");
        emptyRow.innerHTML = `
      <td colspan="11" class="text-center py-4 text-gray-500">
        No holdings available to display.
      </td>`;
        tableBody.appendChild(emptyRow);
        return tableBody;
      }

      // ✅ Proceed with the rest of your logic as-is...
      data.forEach((categoryData) => {
        // your existing loop logic here
      });

      // ✅ Check data[0] and data[1] before using them
      if (data[0]) {
        const summaryGrowthRow = document.createElement("tr");
        summaryGrowthRow.classList.add("bg-light-blue", "text-bold");
        summaryGrowthRow.innerHTML = `...`; // your existing logic for data[0]
        tableBody.appendChild(summaryGrowthRow);
      }

      if (data[1]) {
        const summaryDefensiveRow = document.createElement("tr");
        summaryDefensiveRow.classList.add("bg-light-green", "text-bold");
        summaryDefensiveRow.innerHTML = `...`; // your existing logic for data[1]
        tableBody.appendChild(summaryDefensiveRow);
      }

      if (data[0] && data[1]) {
        const summaryTotalRow = document.createElement("tr");
        summaryTotalRow.classList.add("bg-summary", "text-bold");
        summaryTotalRow.innerHTML = `...`; // your existing logic for totals
        tableBody.appendChild(summaryTotalRow);
      }

      return tableBody;
    }
  }
  const handleDownloadPDF = async () => {
    const date = new Date().toLocaleString();
    const allocationItemsHTML = generateAllocationItems(details);

    const fullHtml = `
<!DOCTYPE html>
<html>
   <head>
      <meta charset="utf-8" />
      <style>
         @page {
         size: A4 portrait;
         margin: 0;
         }
         html, body {
         margin: 0;
         padding: 0;
         font-family:sans-serif;
         overflow: auto;  /* Ensure content can overflow */
         height: 100%; /* Ensure the body fills the entire height */
         }        .pdf-container {
         max-width: 100% !important;
         margin: 20px;
         }
         tr {
         page-break-inside: avoid !important;
         break-inside: avoid !important;
         }
         .custom-header {
         position: relative;
         display: flex;
         justify-content: space-between;
         background-color: #ffffff;
         padding-top: 10px; /* Ensures no padding at the top */
         }
         .logo-container {
         display: flex;
         align-items: center;
         }
         .logo {
         width: 96px; /* Tailwind w-24 = 6rem = 96px */
         max-width: 150px;
         height: auto;
         object-fit: contain;
         margin-right: 1rem;
         }
         .title {
         position: absolute;
         left: 50%;
         transform: translateX(-50%);
         font-size: 1.125rem; /* Tailwind text-lg */
         font-weight: 500;    /* Tailwind font-medium */
         padding: 0;          /* Remove any padding */
         margin: 0;           /* Remove any margin */
         }
         .date {
         font-size: 0.875rem;  /* Tailwind text-sm */
         font-weight: 500;
         color: #000000;
         padding-bottom: 16px;
         }
         .header {
         display: flex;
         justify-content: space-between;
         align-items: flex-start;
         flex-wrap: wrap;
         }
         .title-section {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
   flex-wrap: nowrap;
  width: 100%;
}

         .icon {
         width: 20px;
         height: 20px;
         }
.second-title {
  font-size: 1rem;
  font-weight: 600;
  padding-bottom: 16px;
  margin: 0;
  max-width: 100%;         /* Prevent exceeding container */
  white-space: normal;     /* Allow text to wrap */
}
         .content {
         display: flex;
         gap: 20px;
         margin-top: 8px;
         padding-right: 16px;
         }
         .left-column {
         width: 40%;
         padding-right: 16px;
         border-right: 1px solid black;
         }
         .right-column {
         width: 60%;
         padding-left: 10px;
         padding-left: 10px;
         }
         .info-block {
         margin-bottom: 24px;
         }
         .label {
         font-size: 12px;
         color: #666666;
         font-weight: 500;
         margin: 0;
         }
         .value {
         font-size: 14px;
         font-weight: 500;
         color: #000000;
         margin: 0;
         }
         .section-title {
         font-size: 12px;
         color: #666666;
         font-weight: 500;
         margin-bottom: 0px;
         }
         .description {
         font-size: 12px;
         font-weight: 500;
         color: #000000;
         line-height: 1.6;
         }
         .form-container {
         background-color: #ffffff;
         border: 1px solid #000000;
         border-radius: 6px;
         margin-top: 20px;
         }
         .grid {
         display: grid;
         grid-template-columns: repeat(4, 1fr);
         border-collapse: collapse;
         }
         .cell {
         border-bottom: 1px solid #000000;
         border-right: 1px solid #000000;
         padding: 16px 12px;
         }
         .cell-last {
         border-right: 1px solid #000000;
         padding: 16px 12px;
         }
         .cell:nth-child(4n) {
         border-right: none;
         }
         .cell-last:nth-child(4n) {
         border-right: none;
         }
         .label {
         font-size: 12px;
         font-weight: 500;
         color: #666666;
         margin-bottom: 6px;
         }
         .value {
         font-size: 14px;
         font-weight: 500;
         color: #000000;
         }
         .allocation-container {
         border: 1px solid black;
         border-radius: 8px;
         padding: 16px;
         margin-top: 20px;
         }
         .allocation-header {
         display: flex;
         align-items: center;
         border-bottom: 1px solid black;
         padding-bottom: 8px;
         margin-bottom: 16px;
         }
         .allocation-header img {
         width: 16px;
         height: 16px;
         margin-right: 8px;
         }
         .allocation-header h3 {
         font-size: 16px;
         font-weight: 500;
         margin: 0;
         }
         .allocation-grid {
         display: flex;
         flex-wrap: wrap;
         gap: 20px;
         }
         .allocation-details {
         flex: 1 1 50%;
         }
         .allocation-items {
         display: grid;
         grid-template-columns: repeat(3, 1fr);
         gap: 16px;
         font-size: 12px;
         }
         .allocation-item {
         display: flex;
         flex-direction: column;
         word-break: break-word;
         }
         .allocation-item .product-name {
         font-size: 14px;
         font-weight: 500;
         color: #444;
         }
         .allocation-item .percentage {
         font-size: 14px;
         font-weight: 500;
         margin-top: 4px;
         }
         .chart-container {
         display: flex;
         justify-content: flex-end;
         margin-top: 16px;
         }
         .chart-container img {
         width: 160px;
         height: 160px;
         }
         .page-break {
         page-break-before: always;
         break-before: page;
         display: block;
         height: 0; /* No extra space */
         width: 100%;
         content: "";}
         /* Responsive fallback (1 column on small screens) */
         @media print {
         .grid {
         grid-template-columns: repeat(4, 1fr);
         }
         }
      </style>
   </head>
   <body>
      <div class="pdf-container">
         <div class="custom-header">
            <div class="logo-container">
               <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
            </div>
            <h2 class="title">Factsheet</h2>
            <div class="date">${date}</div>
         </div>
         <div class="header">
            <!-- Title Section with Icon -->
            <div class="title-section">
               <img src="${svgBookBase64}"  alt="Portfolio Icon" class="icon" />
                  <h2 class="second-title">Caprock Model Portfolio - ${
                    details.basic_details.name
                  }</h2>
            </div>
         </div>
         <!-- Content Section -->
         <div class="content">
            <!-- Left Column -->
            <div class="left-column">
               <div class="info-block">
                  <p class="label">Strategy</p>
                  <p class="value">${details.basic_details.name}</p>
               </div>
               <div class="info-block">
                  <p class="label">Type</p>
                  <p class="value">${details.basic_details.strategy_type}</p>
               </div>
               <div class="info-block">
                  <p class="label">Growth</p>
                  <p class="value">${
                    details.basic_details.growth_percentage
                  }</p>
               </div>
               <div class="info-block">
                  <p class="label">Defensive</p>
                  <p class="value">${
                    details.basic_details.defensive_percentage
                  }</p>
               </div>
            </div>
            <!-- Right Column -->
            <div class="right-column">
               <div class="info-block">
                  <p class="label">FUND OBJECTIVE & PROCESS</p>
                  <p class="description">
                     ${details.basic_details.fund_objective_and_process}        
               </div>
               </p>
            </div>
         </div>
         <div class="form-container">
            <div class="grid">
               <!-- Cell -->
               <div class="cell">
                  <div class="label">Platform</div>
                  <div class="value">${
                    details.details.platform != null
                      ? details.details.platform.name
                      : "N/A"
                  }</div>
               </div>
               <div class="cell">
                  <div class="label">Code</div>
                  <div class="value">${details.details.code}</div>
               </div>
               <div class="cell">
                  <div class="label">Min investment</div>
                  <div class="value">
                     $${details.details.minimum_investment
                       .toFixed(2)
                       .toString()
                       .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </div>
               </div>
               <div class="cell">
                  <div class="label">Investment Manager</div>
                  <div class="value">${
                    details.details.investment_manager != null
                      ? details.details.investment_manager.name
                      : "N/A"
                  }</div>
               </div>
               <div class="cell">
                  <div class="label">Sub Advisor</div>
                  <div class="value">${
                    details.details.sub_advisor
                      ? details.details.sub_advisor.name
                      : "N/A"
                  }
                  </div>
               </div>
               <div class="cell">
                  <div class="label">Risk profile</div>
                  <div class="value">${details.details.risk_profile}</div>
               </div>
               <div class="cell">
                  <div class="label">Risk rating</div>
                  <div class="value">${
                    details.details.risk_rating
                      ? details.details.risk_rating
                      : "N/A"
                  }</div>
               </div>
               <div class="cell">
                  <div class="label">Strategy inception date</div>
                  <div class="value">${formatDateList(
                    details.details.strategy_date_creation
                  )}
                  </div>
               </div>
               <div class="cell-last">
                  <div class="label">Investments</div>
                  <div class="value">${details.details.investment_tags.join(
                    ", "
                  )}</div>
               </div>
               <div class="cell-last">
                  <div class="label">SMA Fees</div>
                  <div class="value">${details.details.sma_fee} (+ GST)</div>
               </div>
               <div class="cell-last">
                  <div class="label">Investment Manager Fees</div>
                  <div class="value">${
                    details.details.investment_manager_fee
                  }% + GST
                  </div>
               </div>
               <div class="cell-last" style="border-right: none;">
                  <div class="label">Sub Advisor Fees</div>
                  <div class="value">${
                    details.details.sub_advisor_fee
                  }% + GST</div>
               </div>
            </div>
         </div>
         <div class="allocation-container">
            <div class="allocation-header">
               <img src="${svgGraphBase64}" alt="Icon" />
               <h3>Current Target Allocation</h3>
            </div>
            <div class="allocation-grid">
               <div class="allocation-details">
                  <div class="allocation-items" id="allocation-items">
                     ${allocationItemsHTML}
                  </div>
               </div>
               <div class="chart-container">
                  <img src="${chartImage}" alt="Doughnut Chart" />
               </div>
            </div>
         </div>
      </div>
      <div class="page-break"></div>
      <div class="pdf-container">
         <div style="background-color: #ffffff; margin-bottom: 1rem; padding: 0.5rem; border-radius: 6px;">
            <!-- Header -->
            <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; width: 100%; border-bottom: 1px solid #000; padding-bottom: 0.5rem;">
               <h3 style="display: flex; align-items: center; font-size: 1rem; font-weight: 500; color: #000; margin: 0;">
                  <img src="${svgDiagramBase64}" alt="Portfolio Icon" style="width: 20px; height: 20px; margin-right: 0.5rem;" />
                  <span>Historical Performance</span>
               </h3>
               <div style="display: flex; align-items: center; gap: 0.2rem; font-size: 0.875rem; margin-bottom: 0.5rem;">
                  <span style="color: #555; white-space: nowrap;">Caprock Growth:</span>
                  <span style="font-weight: 500; color: #000; white-space: nowrap;">${
                    details.details.risk_profile
                  }</span>
               </div>
            </div>
            <!-- Chart -->
            <div style="margin-top: 0.5rem;">
               <img src="${historyChartImage}" alt="history Chart" style="width: 100%; max-height: 200px; object-fit: contain;" />
            </div>
            <!-- Note -->
            <div style="font-size: 0.875rem; color: #000; line-height: 1.6; margin-top: 1rem;">
               <p style="font-weight: bold; margin-bottom: 0.25rem;">
                  *Past performance is not a guide to future performance.
               </p>
               <p style="font-weight: 500;">
 ${pastPerformance}
               </p>
            </div>
            <!-- Disclaimer -->
            <div style="margin-top: 1.5rem; border-bottom: 1px solid #000; padding-bottom: 0.5rem;">
               <h3 style="display: flex; align-items: center; font-size: 1rem; font-weight: 500; color: #000; margin: 0;">
                  <img src="${svgInfoCircleBase64}" alt="Info Icon" style="width: 20px; height: 20px; margin-right: 0.5rem;" />
                  <span>Disclaimer</span>
               </h3>
               <p style="font-size: 0.875rem; color: #000; font-weight: 500; line-height: 1.6; margin-top: 0.5rem;">
 ${disclaimer}
               </p>
            </div>
            <!-- Copyright -->
            <div style="margin-top: 1.5rem; border-bottom: 1px solid #000; padding-bottom: 0.5rem;">
               <h3 style="display: flex; align-items: center; font-size: 1rem; font-weight: 500; color: #000; margin: 0;">
                  <img src="${svgInfoCircleBase64}" alt="Info Icon" style="width: 20px; height: 20px; margin-right: 0.5rem;" />
                  <span>Copyright</span>
               </h3>
               <p style="font-size: 0.875rem; color: #000; font-weight: 500; line-height: 1.6; margin-top: 0.5rem;">
 ${copyright}
               </p>
            </div>
         </div>
      </div>
   </body>
</html>
  `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Factsheet - Caprock Model Portfolio - ${factSheetFileName}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHidden(false);
  };
  const getDividend = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/dividend/portfolio/total_dividends`;
    let bodyData = {
      portfolio_id: investmentId,
      user_id: customerId,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getAllInvestmentDividend = async () => {
    let toastMessage = null;
    try {
      const response = await getDividend();

      if (response.status == 200) {
        setTotalDividend(response.data.total_dividends);
        setTotalThreshold(response.data.reinvest_threshold);
        setTotalInvested(response.data.total_invested);
        setTotalInvestedDetails(response.data.balance_changes);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          toastMessage = { message: response.message, type: "error" };
        }
        setTotalDividend(0);
        setTotalThreshold(0);
      }
    } catch (err) {
      setTotalDividend(0);
      setTotalThreshold(0);
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setIsLoadingGraph(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleDownloadInvestorListPDFTable = async () => {
    const columns = [
      { label: "Investor Name", key: "investorName" },
      { label: "Date Invested", key: "dateInvested" },
      { label: "Investment Amount", key: "investmentAmount" },
      { label: "Principle Paid", key: "principlePaid" },
      { label: "Maturity Date", key: "maturityDate" },
    ];
    const couponColumns = [
      { label: "Description", key: "description" },
      { label: "Date Due", key: "dueDate" },
      { label: "Coupon Amount Due", key: "couponAmount" },
      { label: "Paid", key: "paid" },
      { label: "Balance", key: "balance" },
    ];
    const date = new Date().toLocaleString();
    const tableHeadElement = createTableHeader(columns);
    const tableHeader = tableHeadElement.outerHTML;
    const tableBodyElement = createTableBody(investorListData, columns);
    const tableBody = tableBodyElement.outerHTML;
    //coupons
    const tableHeadElementCoupon = createTableHeader(couponColumns);
    const tableHeaderCoupon = tableHeadElement.outerHTML;
    const tableBodyElementCoupon = createTableBody(
      couponListData,
      couponColumns
    );
    const tableBodyCoupon = tableBodyElement.outerHTML;
    const fullHtml = `
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8" />
            <style>
            @page {
      size: A4 landscape;
      margin: 0;
    }
      html, body {
              margin: 0;
              padding: 0;
                        font-family:sans-serif;
      overflow: auto;  /* Ensure content can overflow */
    
              height: 100%; /* Ensure the body fills the entire height */
            }        .pdf-container {
                max-width: 100% !important;
                margin: 20px;
              }
              tr {
                page-break-inside: avoid !important;
                break-inside: avoid !important;
              }
      
              .custom-header {
                position: relative;
                display: flex;
                justify-content: space-between;
                background-color: #ffffff;
                padding-top: 10px; /* Ensures no padding at the top */
              }
      
              .logo-container {
                display: flex;
                align-items: center;
              }
      
              .logo {
                width: 96px; /* Tailwind w-24 = 6rem = 96px */
                max-width: 150px;
                height: auto;
                object-fit: contain;
                margin-right: 1rem;
              }
      
              .title {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                font-size: 1.125rem; /* Tailwind text-lg */
                font-weight: 500;    /* Tailwind font-medium */
                padding: 0;          /* Remove any padding */
                margin: 0;           /* Remove any margin */
              }
      
              .date {
                font-size: 0.875rem;  /* Tailwind text-sm */
                font-weight: 500;
                color: #000000;
                padding-bottom: 16px;
              }
    
      
    .page-break {
             page-break-before: always;
      break-before: page;
      display: block;
      height: 0; /* No extra space */
      width: 100%;
      content: "";}
          table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;
        }
    
        thead {
          font-size: 10px;
          color: #6B7280; /* Tailwind text-labelColour equivalent */
        }
    
        th {
          border-bottom: 1px solid #000;
          padding: 8px;
          text-align: left;
        }
              td {
          padding: 6px;
          font-size: 10px;
          vertical-align: middle;
          text-align: left;
        }
          .tbody-tr{
                      background-color: #F9F9F9;
                      margin-bottom: 10px;
    
          }
            </style>
          </head>
          <body>
         <div class="pdf-container">
            <div class="custom-header">
              <div class="logo-container">
                <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
              </div>
              <h2 class="title">List Of Investors</h2>
              <div class="date">${date}</div>
            </div>
            
      <table id="dynamic-table">
      ${tableHeader}
        ${tableBody}
    
      </table>
                          <div class="page-break"></div>

                 <div class="custom-header">
                       <div class="logo-container">
                <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
              </div>
              <h2 class="title">Coupons</h2>
                            <div class="date">${date}</div>
            </div>
            
      <table id="dynamic-table">
      ${tableHeaderCoupon}
        ${tableBodyCoupon}
    
      </table>
        
          </div> 
    
               </body>
        </html>
      `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Investment Portfolios-${formattedDate}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHiddenInvestorList(false);
  };
  const handleCustomTimeChange = (change) => {
    setCustomTime((prev) => Math.max(1, prev + change));
    setSelectedFilter("CUSTOM");
  };
  const handleDownloadValuationPDF = async () => {
    const date = new Date().toLocaleString();
    const allocationItemsHTML = generateAllocationItems(holdingValuationData);
    const tableBodyElement = populateTableHolding(
      holdingValuationData.holdings_breakdown.categories.length > 0
        ? holdingValuationData.holdings_breakdown.categories
        : []
    );
    const tableBody = tableBodyElement.outerHTML;
    const fullHtml = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8" />
        <style>
                @page {
  size: A4 landscape;
  margin: 0;
}
  html, body {
          margin: 0;
          padding: 0;
                    font-family:sans-serif;
  overflow: auto;  /* Ensure content can overflow */

          height: 100%; /* Ensure the body fills the entire height */
        }        .pdf-container {
            max-width: 100% !important;
            margin: 20px;
          }
          tr {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
          }
  
          .custom-header {
            position: relative;
            display: flex;
            justify-content: space-between;
            background-color: #ffffff;
            padding-top: 10px; /* Ensures no padding at the top */
          }
  
          .logo-container {
            display: flex;
            align-items: center;
          }
  
          .logo {
            width: 96px; /* Tailwind w-24 = 6rem = 96px */
            max-width: 150px;
            height: auto;
            object-fit: contain;
            margin-right: 1rem;
          }
  
          .title {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-size: 1.125rem; /* Tailwind text-lg */
            font-weight: 500;    /* Tailwind font-medium */
            padding: 0;          /* Remove any padding */
            margin: 0;           /* Remove any margin */
          }
  
          .date {
            font-size: 0.875rem;  /* Tailwind text-sm */
            font-weight: 500;
            color: #000000;
            padding-bottom: 16px;
          }
                  .header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
      }

        .title-section {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
   flex-wrap: nowrap;
  width: 100%;
}

         .icon {
         width: 20px;
         height: 20px;
         }
.second-title {
  font-size: 1rem;
  font-weight: 600;
  padding-bottom: 16px;
  margin: 0;
  max-width: 100%;         /* Prevent exceeding container */
  white-space: normal;     /* Allow text to wrap */
}
      .label {
        font-size: 12px;
        color: #666666;
        font-weight: 500;
        margin: 0;
      }

      .value {
        font-size: 14px;
        font-weight: 500;
        color: #000000;
        margin: 0;
      }

      .section-title {
        font-size: 12px;
        color: #666666;
        font-weight: 500;
        margin-bottom: 0px;
      }

      .description {
        font-size: 12px;
        font-weight: 500;
        color: #000000;
        line-height: 1.6;
      }
              .form-container {
        background-color: #ffffff;
        border: 1px solid #000000;
        border-radius: 6px;
        margin-top: 0px;
      }

      .grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        border-collapse: collapse;
      }

      .cell {
        border-bottom: 1px solid #000000;
        border-right: 1px solid #000000;
        padding: 16px 12px;
      }
  .cell-last {
        border-right: 1px solid #000000;
        padding: 16px 12px;
      }
      .cell:nth-child(4n) {
        border-right: none;
      }
  .cell-last:nth-child(4n) {
        border-right: none;
      }

      .label {
        font-size: 12px;
        font-weight: 500;
        color: #666666;
        margin-bottom: 6px;
      }

      .value {
        font-size: 14px;
        font-weight: 500;
        color: #000000;
      }
      .allocation-container {
        border: 1px solid black;
        border-radius: 8px;
        padding: 16px;
        margin-top: 20px;
      }

      .allocation-header {
        display: flex;
        align-items: center;
        border-bottom: 1px solid black;
        padding-bottom: 8px;
        margin-bottom: 16px;
      }

      .allocation-header img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }

      .allocation-header h3 {
        font-size: 16px;
        font-weight: 500;
        margin: 0;
      }

      .allocation-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
      }

      .allocation-details {
        flex: 1 1 50%;
      }

      .allocation-items {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
        font-size: 12px;
      }

      .allocation-item {
        display: flex;
        flex-direction: column;
        word-break: break-word;
      }

      .allocation-item .product-name {
        font-size: 14px;
        font-weight: 500;
        color: #444;
      }

      .allocation-item .percentage {
        font-size: 14px;
        font-weight: 500;
        margin-top: 4px;
      }

      .chart-container {
        display: flex;
        justify-content: flex-end;
        margin-top: 16px;
      }

      .chart-container img {
        width: 160px;
        height: 160px;
      }
.page-break {
         page-break-before: always;
  break-before: page;
  display: block;
  height: 0; /* No extra space */
  width: 100%;
  content: "";}
      /* Responsive fallback (1 column on small screens) */
      @media print {
        .grid {
          grid-template-columns: repeat(4, 1fr);
        }
      }
            table {
      width: 100%;
      border-collapse: collapse;
      font-size: 10px;
      margin-top: 1rem;
    }

    th, td {
      border: 1px solid #ffffff;
      padding: 0.5rem 1rem;
    }

    /* Header row styling */
    th {
      background-color: #6AA7D3;
      color: white;
      font-weight: bold;
    }

    /* Specific styles for 'Market Price' column header */
    .market-price {
      background-color: #F4D580;
    }

    /* Optional styling for overflow if required */
    .overflow-x-auto {
      overflow-x: auto;
    }
              .bg-light-blue {
            background-color: #92C5EA;
        }
         .bg-product-blue {
            background-color: #C6DFF1;
        }
                .bg-stock-blue {
            background-color: #E6F3FC;
        }
            .bg-summary{
                        background-color: #EAEAEA;

            }
             .bg-product-green {
            background-color: #C0E2C1;
        }
             .bg-stock-green {
            background-color: #E7F5E8;
        }

        .bg-light-green {
            background-color: #A9D4AB;
        }

        .bg-off-white {
            background-color: #EAEAEA;
        }

        .text-bold {
            font-weight: bold;
        }
        .text-product{
                    font-weight: bold;
color: #005A9C;
        }

        .text-center {
            text-align: center;
        }

        .text-right {
            text-align: right;
        }

        .font-small {
            font-size: 12px;
        }

        .page-break {
            page-break-before: always;
        }
        </style>
      </head>
      <body>
     <div class="pdf-container">
        <div class="custom-header">
          <div class="logo-container">
            <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
          </div>
          <h2 class="title">Holding Valuation Report</h2>
          <div class="date">${date}</div>
        </div>
                  <div class="header">
      <!-- Title Section with Icon -->
      <div class="title-section">
        <img src="${svgBookBase64}"  alt="Portfolio Icon" class="icon" />
          <h2 class="second-title">${holdingValuationData.strategy_name}</h2>
      </div>
    </div>
        <div class="form-container">
      <div class="grid">
        <!-- Cell -->
        <div class="cell">
          <div class="label">Client Id</div>
          <div class="value">${
            holdingValuationData.client_details.client_id == null
              ? "Not Found"
              : holdingValuationData.client_details.client_id
          }</div>
        </div>
        <div class="cell">
          <div class="label"> Broker Id</div>
          <div class="value">${
            holdingValuationData.client_details.broker_id == null
              ? "Not Found"
              : holdingValuationData.client_details.broker_id
          }</div>
        </div>
        <div class="cell">
          <div class="label">Hin</div>
          <div class="value">
          ${
            holdingValuationData.client_details.bd_hin_number == null
              ? "Not Found"
              : holdingValuationData.client_details.bd_hin_number
          }</div>
        </div>
        <div class="cell">
          <div class="label">Risk profile</div>
          <div class="value">${holdingValuationData.client_details.risk_profile}
</div>
        </div>

        <div class="cell-last">
          <div class="label">Type</div>
          <div class="value">${
            holdingValuationData.client_details.strategy_type
          }</div>
        </div>
        <div class="cell-last">
          <div class="label">Investment Date</div>
          <div class="value">${formatDateList(
            holdingValuationData.strategy_creation_date
          )}</div>
        </div>
        <div class="cell-last">
          <div class="label">Growth</div>
          <div class="value">${
            holdingValuationData.client_details.growth_percentage
          }</div>
        </div>
        <div class="cell-last">
          <div class="label">Defensive</div>
          <div class="value">${
            holdingValuationData.client_details.defensive_percentage
          }</div>
        </div>
        </div>
      </div>
        <div class="allocation-container">
      <div class="allocation-header">
        <img src="${svgGraphBase64}" alt="Icon" />
        <h3>Current Target Allocation</h3>
      </div>

      <div class="allocation-grid">
        <div class="allocation-details">
          <div class="allocation-items" id="allocation-items">
               ${allocationItemsHTML}
          </div>
        </div>

        <div class="chart-container">
          <img src="${chartImage}" alt="Doughnut Chart" />
        </div>
      </div>
    </div>
    
  <div class="overflow-x-auto">
    <table>
      <thead>
        <tr>
          <th>No</th>
          <th>Strategic Asset Allocation</th>
          <th>Code</th>
          <th>Holdings</th>
          <th>Cost Base</th>
          <th>Value($)</th>
          <th>Weight(%)</th>
          <th>Market Price</th>
          <th>Value ($)</th>
          <th>P/L</th>
                    <th>Weight(%)</th>

        </tr>
      </thead>
                    ${tableBody}


    </table>
  </div>
          <!-- Disclaimer -->
      <div style="margin-top: 4rem;margin-left: 0rem; margin-right: 0rem; border-bottom: 1px solid #000; padding-bottom: 0.5rem;">
         <h3 style="display: flex; align-items: center; font-size: 1rem; font-weight: 500; color: #000; margin: 0;">
            <img src="${svgInfoCircleBase64}" alt="Info Icon" style="width: 20px; height: 20px; margin-right: 0.5rem;" />
            <span>Disclaimer</span>
         </h3>
         <p style="font-size: 0.775rem; color: #000; font-weight: 500; line-height: 1.6; margin-top: 0.5rem;">
                  ${disclaimer}   </p>
      </div>
         <div style="margin-top: 2rem;margin-left: 0rem; margin-right: 0rem; border-bottom: 1px solid #000; padding-bottom: 0.5rem;">
         <h3 style="display: flex; align-items: center; font-size: 1rem; font-weight: 500; color: #000; margin: 0;">
            <img src="${svgInfoCircleBase64}" alt="Info Icon" style="width: 20px; height: 20px; margin-right: 0.5rem;" />
            <span>Copyright</span>
         </h3>
         <p style="font-size: 0.775rem; color: #000; font-weight: 500; line-height: 1.6; margin-top: 0.5rem;">
                  ${copyright}   </p>
      </div>
    </div>

           </body>
    </html>
  `;
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Holding Valuation-${formattedDate}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHiddenReport(false);
  };
  useEffect(() => {
    if (isHidden == true) {
      handleDownloadPDF();
    }
  }, [isHidden, factSheetFileName, investmentId]);
  // End here
  const handleDownloadTaxPDF = async () => {
    const columns = [
      { label: "Investor Name", key: "investorName" },
      { label: "Date Invested", key: "dateInvested" },
      { label: "Investment Amount", key: "investmentAmount" },
      { label: "Principle Paid", key: "principlePaid" },
      { label: "Maturity Date", key: "maturityDate" },
    ];
    const couponColumns = [
      { label: "Description", key: "description" },
      { label: "Date Due", key: "dueDate" },
      { label: "Coupon Amount Due", key: "couponAmount" },
      { label: "Paid", key: "paid" },
      { label: "Balance", key: "balance" },
    ];
    const date = new Date().toLocaleString();
    const taxIncome = renderStrategyLayout(data);
    const taxBodyIncome = taxIncome.outerHTML;
    const capitalGain = renderCapitalGainLayout(capitalGainData);
    const capitalGainBody = capitalGain.outerHTML;
    const domesticDividend = renderGenericSummaryAndTableLayout({
      title: "Domestic Dividends",
      summaryData: {
        "Unfranked Dividend": 4200,
        "Unfranked CFI Dividend": 11000,
        "Franked Dividend": 11000,
        "Franking Credits": 11000,
        "Franking Credits Allowed": 11000,
        "TFN WHT": 11000,
        "Non-Resident WHT": 11000,
        "Total Amount Credited": 11000,
      },
      tableData: [
        {
          name: "APA INFRASTRUCTURE TRUST",
          id: 1,
          totalUnfrankedDividendBeforeWHT: 1000,
          totalUnfrankedCFIDividendBeforeWHT: 1000,
          totalFrankedDividendBeforeWHT: 1000,
          totalFrankingCredits: 1000,
          totalFrankingCreditsAllowed: 1000,
          totalTFNWHT: 1000,
          totalNonResidentWHT: 1000,
          totalAmountCredited: 1000,
          items: [
            {
              valueDate: "28/12/2024",
              ExDate: "28/12/2024",
              amountPerSecurity: "1000",
              quantity: "12,889.00",
              unfrankedDividendBeforeWHT: 1000,
              unfrankedCFIDividendBeforeWHT: 1000,
              frankedDividendBeforeWHT: 1000,
              frankingCredits: 1000,
              frankingCreditsAllowed: 1000,
              TFNWHT: 1000,
              nonResidentWHT: 1000,
              amountCredited: 1000,
            },
          ],
        },
        {
          name: "COMMONWEALTH BANK. ORDINARY",
          id: 2,
          totalUnfrankedDividendBeforeWHT: 1000,
          totalUnfrankedCFIDividendBeforeWHT: 1000,
          totalFrankedDividendBeforeWHT: 1000,
          totalFrankingCredits: 1000,
          totalFrankingCreditsAllowed: 1000,
          totalTFNWHT: 1000,
          totalNonResidentWHT: 1000,
          totalAmountCredited: 1000,
          items: [
            {
              valueDate: "28/12/2024",
              ExDate: "28/12/2024",
              amountPerSecurity: 1000,
              quantity: 12989,
              unfrankedDividendBeforeWHT: 1000,
              unfrankedCFIDividendBeforeWHT: 1000,
              frankedDividendBeforeWHT: 1000,
              frankingCredits: 1000,
              frankingCreditsAllowed: 1000,
              TFNWHT: 1000,
              nonResidentWHT: 1000,
              amountCredited: 1000,
            },
          ],
        },
      ],
      columns: [
        { label: "Value Date", key: "valueDate" },
        { label: "Ex Date", key: "ExDate" },
        { label: "Amount Per Security", key: "amountPerSecurity" },
        { label: "Quantity", key: "quantity" },
        {
          label: "Unfranked dividend before WHT",
          key: "unfrankedDividendBeforeWHT",
        },
        {
          label: "Unfranked CFI dividend before WHT",
          key: "unfrankedCFIDividendBeforeWHT",
        },
        {
          label: "Franked Dividend before WHT",
          key: "frankedDividendBeforeWHT",
        },
        { label: "Franking Credits", key: "frankingCredits" },
        { label: "Franking credits allowed", key: "frankingCreditsAllowed" },
        { label: "TFN WHT", key: "TFNWHT" },
        { label: "Non-resident WHT", key: "nonResidentWHT" },
        { label: "Amount credited", key: "amountCredited" },
      ],
      subtotals: {
        frankingCredits: "totalFrankingCredit",
        unfrankedDividendBeforeWHT: "totalUnfrankedDividendBeforeWHT",
        unfrankedCFIDividendBeforeWHT: "totalUnfrankedCFIDividendBeforeWHT",
        frankedDividendBeforeWHT: "totalFrankedDividendBeforeWHT",
        frankingCredits: "totalFrankingCredits",

        frankingCreditsAllowed: "totalFrankingCreditsAllowed",
        TFNWHT: "totalTFNWHT",
        nonResidentWHT: "totalNonResidentWHT",
        amountCredited: "totalAmountCredited",
      },
    });
    const domesticDividendBody = domesticDividend.outerHTML;
    const internationalDividend = renderGenericSummaryAndTableLayout({
      title: "International Dividends",
      summaryData: {
        "Foreign currency amount before WHT": 4200,
        "Foreign currency amount after WHT": 11000,
        "AUD amount before WHT": 11000,
        "Foreign WHT": 11000,
        "Franking Credits Allowed": 11000,
        "TFN WHT": 11000,
        "Total Amount Credited": 11000,
      },
      tableData: [
        {
          name: "VANGUARD US TOTAL MARKET SHARES INDEX ETF",
          id: 1,
          totalForeignCurrencyAmountBeforeWHT: 1000,
          totalForeignCurrencyAmountAfterWHT: 1000,
          totalAUDAmountBeforeWHT: 1000,
          totalForeignWHT: 1000,
          totalAmountCredited: 1000,
          totalAustralianFrankingCreditsFromANZcompany: 1000,
          totalFrankingCreditsAllowed: 1000,
          totalTFNWHT: 1000,
          totalQuantity: 1000,
          totalAmountPerSecurity: 1000,
          items: [
            {
              valueDate: "28/12/2024",
              ExDate: "28/12/2024",
              amountPerSecurity: "1000",
              quantity: "12,889.00",
              foreignCurrency: "12,889.00",
              foreignCurrencyAmountBeforeWHT: 1000,
              foreignCurrencyAmountAfterWHT: 1000,
              exchangeRate: 2.3,
              AUDAmountBeforeWHT: 1000,
              australianFrankingCreditsFromANZcompany: 1000,
              frankingCreditsAllowed: 1000,
              TFNWHT: 1000,
              foreignWHT: 1000,
              amountCredited: 1000,
            },
          ],
        },
      ],
      columns: [
        { label: "Value Date", key: "valueDate" },
        { label: "Ex Date", key: "ExDate" },
        { label: "Amount Per Security", key: "amountPerSecurity" },
        { label: "Quantity", key: "quantity" },
        {
          label: "Foreign currency",
          key: "foreignCurrency",
        },
        {
          label: "Foreign currency amount before WHT",
          key: "foreignCurrencyAmountBeforeWHT",
        },
        {
          label: "Foreign currency amount after WHT",
          key: "foreignCurrencyAmountAfterWHT",
        },
        { label: "Exchange Rate", key: "exchangeRate" },
        { label: "AUD amount before WHT", key: "AUDAmountBeforeWHT" },
        {
          label: "Australian franking credits from a NZ company",
          key: "australianFrankingCreditsFromANZcompany",
        },
        { label: "Franking credits allowed", key: "frankingCreditsAllowed" },
        { label: "TFN WHT", key: "TFNWHT" },
        { label: "Foreign WHT", key: "foreignWHT" },
        { label: "Amount credited", key: "amountCredited" },
      ],
      subtotals: {
        amountPerSecurity: "totalAmountPerSecurity",
        quantity: "totalQuantity",
        foreignCurrencyAmountBeforeWHT: "totalForeignCurrencyAmountBeforeWHT",
        foreignCurrencyAmountAfterWHT: "totalForeignCurrencyAmountAfterWHT",
        AUDAmountBeforeWHT: "totalAUDAmountBeforeWHT",
        australianFrankingCreditsFromANZcompany:
          "totalAustralianFrankingCreditsFromANZcompany",
        frankingCreditsAllowed: "totalFrankingCreditsAllowed",
        TFNWHT: "totalTFNWHT",
        foreignWHT: "totalForeignWHT",
        amountCredited: "totalAmountCredited",
      },
    });
    const internationalDividendBody = internationalDividend.outerHTML;
    const trustDistribution = await renderTrustDistributionLayout(trustData);
    const trustDistributionBody = trustDistribution.outerHTML;

    const estimatedDividendAndDistributions =
      renderGenericSummaryAndTableLayout({
        title: "Estimated Dividends & Distributions",
        summaryData: {
          "Franking Credit": 4200,
          "Est. Dividend": 11000,
        },
        tableData: [
          {
            name: "Company A",
            totalFrankingCredit: 2200,
            totalEstimatedDividend: 5500,
            items: [
              {
                code: "CBA",
                ExDate: "2025-07-01",
                paymentDate: "2025-07-15",
                type: "Interim",
                dividend: 1.2,
                franking: "100%",
                balance: 2000,
                frankingCredits: 400,
                estimatedDividend: 600,
              },
            ],
          },
        ],
        columns: [
          { label: "Code", key: "code" },
          { label: "Ex Div. Date", key: "ExDate" },
          { label: "Payment Date", key: "paymentDate" },
          { label: "Type", key: "type" },
          { label: "Dividend", key: "dividend" },
          { label: "Franking %", key: "franking" },
          { label: "Balance", key: "balance" },
          { label: "Franking Credits", key: "frankingCredits" },
          { label: "Est. Dividend", key: "estimatedDividend" },
        ],
        subtotals: {
          frankingCredits: "totalFrankingCredit",
          estimatedDividend: "totalEstimatedDividend",
        },
      });

    const estimatedDividendAndDistributionsBody =
      estimatedDividendAndDistributions.outerHTML;

    const transactions = renderGenericSummaryAndTableLayout({
      title: "Transaction",
      summaryData: {
        "Transaction Summary": 4200,
      },
      tableData: [
        {
          name: "A2M - THE A2 MILK COMPANY ORDINARY",
          totalQuantity: 2200,
          totalTaxValue: 5500,
          items: [
            {
              code: "A2M",
              date: "28/11/2022",
              type: "Buy",
              Action: "S22865103",
              quality: 121,
              price: "$5.4",
              tradeValue: "$5.4",
              Brokerage: "$5.4",
              otherFees: "$0.00",
              GST: "$5.4",
              totalValue: "$112.00",
              taxValue: "$112.00",
            },
            {
              code: "A2M",
              date: "28/11/2022",
              type: "Buy",
              Action: "S22865103",
              quality: 121,
              price: "$5.4",
              tradeValue: "$5.4",
              Brokerage: "$5.4",
              otherFees: "$0.00",
              GST: "$5.4",
              totalValue: "$112.00",
              taxValue: "$112.00",
            },
            {
              code: "A2M",
              date: "28/11/2022",
              type: "Buy",
              Action: "S22865103",
              quality: 121,
              price: "$5.4",
              tradeValue: "$5.4",
              Brokerage: "$5.4",
              otherFees: "$0.00",
              GST: "$5.4",
              totalValue: "$112.00",
              taxValue: "$112.00",
            },
            {
              code: "A2M",
              date: "28/11/2022",
              type: "Buy",
              Action: "S22865103",
              quality: 121,
              price: "$5.4",
              tradeValue: "$5.4",
              Brokerage: "$5.4",
              otherFees: "$0.00",
              GST: "$5.4",
              totalValue: "$112.00",
              taxValue: "$112.00",
            },
          ],
        },
        {
          name: "ALQ - ALS LTD ORDINARY",
          totalQuantity: 2200,
          totalTaxValue: 5500,
          items: [
            {
              code: "ALQ",
              date: "28/11/2022",
              type: "Buy",
              Action: "S22865103",
              quality: 121,
              price: "$5.4",
              tradeValue: "$5.4",
              Brokerage: "$5.4",
              otherFees: "$0.00",
              GST: "$5.4",
              totalValue: "$112.00",
              taxValue: "$112.00",
            },
            {
              code: "ALQ",
              date: "28/11/2022",
              type: "Buy",
              Action: "S22865103",
              quality: 121,
              price: "$5.4",
              tradeValue: "$5.4",
              Brokerage: "$5.4",
              otherFees: "$0.00",
              GST: "$5.4",
              totalValue: "$112.00",
              taxValue: "$112.00",
            },
            {
              code: "A2M",
              date: "28/11/2022",
              type: "Buy",
              Action: "S22865103",
              quality: 121,
              price: "$5.4",
              tradeValue: "$5.4",
              Brokerage: "$5.4",
              otherFees: "$0.00",
              GST: "$5.4",
              totalValue: "$112.00",
              taxValue: "$112.00",
            },
          ],
        },
      ],
      columns: [
        { label: "Code", key: "code" },
        { label: "Date", key: "date" },
        { label: "Type", key: "type" },
        { label: "Action", key: "Action" },
        { label: "Quantity", key: "quality" },
        { label: "Unit Price", key: "price" },
        { label: "Trade Value", key: "tradeValue" },
        { label: "Brokerage", key: "Brokerage" },
        { label: "Other Fees", key: "otherFees" },
        { label: "GST", key: "GST" },
        { label: "Total Value", key: "totalValue" },
        { label: "Tax Value", key: "taxValue" },
      ],
      subtotals: {
        quality: "totalQuantity",
        taxValue: "totalTaxValue",
      },
    });

    const transactionBody = transactions.outerHTML;
    const holdings = renderGenericSummaryAndTableLayout({
      title: "Holdings Valuation",
      summaryData: {
        "Holding Valuation Summary": 752846.09,
      },
      tableData: [
        {
          name: "Equities",
          totalValue: 2200,
          items: [
            {
              code: "A2M",
              description: "A2 MILK FPO NZ",
              quantity: "5217",
              price: "$5.95",
              value: "$5.4",
            },
            {
              code: "ALQ",
              description: "ALS FPO",
              quantity: "5217",
              price: "$5.95",
              value: "$5.4",
            },
          ],
        },
        {
          name: "Warrants",
          totalValue: 2200,
          items: [
            {
              code: "PMGOLD",
              description: "GOLD CORP PMGOLD",
              quantity: "5217",
              price: "$5.95",
              value: "$5.4",
            },
          ],
        },
      ],
      columns: [
        { label: "ASX Code", key: "code" },
        { label: "Description", key: "description" },
        { label: "Quantity", key: "quantity" },
        { label: "Price", key: "price" },
        { label: "Value", key: "value" },
      ],
      subtotals: {
        value: "totalValue",
      },
    });

    const holdingBody = holdings.outerHTML;
    const brokerageInfo = renderGenericSummaryAndTableLayout({
      title: "Brokerage & Info Services",
      summaryData: {
        "Brokerage Grand Total": 752846.09,
        "Brokerage Total Amount": 752846.09,
        "Brokerage Total GST": 752846.09,
        "Information Services Grand Total": 752846.09,
        "Information Services Total Amount": 752846.09,
        "Information Services Total GST": 752846.09,
      },
      tableData: [
        {
          name: "November 2022",
          totalAmount: 2200,
          totalGST: 2200,
          grandTotal: 11100,
          items: [
            {
              feeDescription: "Brokerage and Trail Fees",
              amount: "$5.95",
              gst: "5217",
              total: "$5.95",
            },
            {
              feeDescription: "Information Services",
              amount: "$5.95",
              gst: "5217",
              total: "$5.95",
            },
          ],
        },
        {
          name: "February 2023",
          totalAmount: 2200,
          totalGST: 2200,
          grandTotal: 11100,
          items: [
            {
              feeDescription: "Brokerage and Trail Fees",
              amount: "$5.95",
              gst: "5217",
              total: "$5.95",
            },
            {
              feeDescription: "Information Services",
              amount: "$5.95",
              gst: "5217",
              total: "$5.95",
            },
          ],
        },
      ],
      columns: [
        { label: "Fee Description", key: "feeDescription" },
        { label: "Amount", key: "amount" },
        { label: "GST", key: "gst" },
        { label: "Total", key: "total" },
      ],
      subtotals: {
        amount: "totalAmount",
        gst: "totalGST",
        total: "grandTotal",
      },
    });

    const brokerageInfoBody = brokerageInfo.outerHTML;
    const tableHeadElement = createTableHeader(columns);
    const tableHeader = tableHeadElement.outerHTML;
    const tableBodyElement = createTableBody(investorListData, columns);
    const tableBody = tableBodyElement.outerHTML;
    //coupons
    const tableHeadElementCoupon = createTableHeader(couponColumns);
    const tableHeaderCoupon = tableHeadElementCoupon.outerHTML;
    const tableBodyElementCoupon = createTableBody(
      couponListData,
      couponColumns
    );
    const tableBodyCoupon = tableBodyElementCoupon.outerHTML;

    const transactionHistory = renderGenericSummaryAndTableLayout({
      title: "Your Cash Account Transaction Details",
      summaryData: {
        "Total Fees": 752846.09,
      },
      tableData: [
        {
          name: "November 2024",
          items: [
            {
              date: "09/11/2024",
              details: "Deposit Client Deposit #ref12245284248552",
              withdraw: "-",
              deposit: "$5.95",
              balance: "$5.95",
            },
            {
              date: "12/11/2024",
              details: "Deposit Client Deposit #ref12245284248552",
              withdraw: "-",
              deposit: "$5.95",
              balance: "$5.95",
            },
            {
              date: "30/11/2024",
              details: "Deposit Client Deposit #ref12245284248552",
              withdraw: "$5.95",
              deposit: "-",
              balance: "$5.95",
            },
          ],
        },
        {
          name: "December 2024",
          items: [
            {
              date: "10/12/2024",
              details: "Deposit Client Deposit #ref12245284248552",
              withdraw: "-",
              deposit: "$5.95",
              balance: "$5.95",
            },
            {
              date: "12/12/2024",
              details: "Deposit Client Deposit #ref12245284248552",
              withdraw: "-",
              deposit: "$5.95",
              balance: "$5.95",
            },
            {
              date: "23/12/2024",
              details: "Deposit Client Deposit #ref12245284248552",
              withdraw: "$5.95",
              deposit: "-",
              balance: "$5.95",
            },
          ],
        },
      ],
      columns: [
        { label: "Date", key: "date" },
        { label: "Detail", key: "details" },
        { label: "Withdrawls", key: "withdraw" },
        { label: "Deposits", key: "deposit" },
        { label: "Balance", key: "balance" },
      ],
      subtotals: {},
    });

    const transactionHistoryBody = transactionHistory.outerHTML;
    const fullHtml = `
    <!DOCTYPE html>
<html>
   <head>
      <meta charset="utf-8" />
      <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
      <style>
         @page {
         size: A4 landscape;
         margin-bottom:8mm;
         margin-top:0mm;
         margin-left:0mm;
         margin-right:0mm;        @bottom-center {
         content: "Page " counter(page) " of " counter(pages);
         font-size: 10px;
         color: #555;
         }
         }
         html, body {
         margin: 0;
         padding: 0;
         font-family:sans-serif;
         overflow: auto;  /* Ensure content can overflow */
         height: 100%; /* Ensure the body fills the entire height */
         }        .pdf-container {
         max-width: 100% !important;
         margin: 20px;
         }
         html {
         counter-reset: page;
         }
         th, td {
         break-inside: avoid !important;
         page-break-inside: avoid !important;
         }
         .custom-header {
         position: relative;
         display: flex;
         justify-content: space-between;
         background-color: #ffffff;
         padding-top: 10px; /* Ensures no padding at the top */
         }
         .logo-container {
         display: flex;
         align-items: center;
         }
         .logo {
         width: 96px; /* Tailwind w-24 = 6rem = 96px */
         max-width: 150px;
         height: auto;
         object-fit: contain;
         margin-right: 1rem;
         }
         .title {
         position: absolute;
         left: 50%;
         transform: translateX(-50%);
         font-size: 1.125rem; /* Tailwind text-lg */
         font-weight: 500;    /* Tailwind font-medium */
         padding: 0;          /* Remove any padding */
         margin: 0;           /* Remove any margin */
         }
         .date {
         font-size: 0.875rem;  /* Tailwind text-sm */
         font-weight: 500;
         color: #000000;
         padding-bottom: 16px;
         }
         .header {
         display: flex;
         justify-content: space-between;
         align-items: flex-start;
         flex-wrap: wrap;
         }
         .title-section {
         display: flex;
         align-items: center;
         gap: 12px;
         background-color: #f9fafb;         /* Light neutral background */
         padding: 14px 20px;
         border-left: 4px solid #9ca3af;    /* Gray-400 */
         border-radius: 10px;
         margin: 24px 0 16px;
         box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
         }
         .second-title {
         font-size: 1.25rem;                /* 20px */
         font-weight: 600;
         color: #111827;                    /* Gray-900 */
         margin: 0;
         white-space: nowrap;
         overflow: hidden;
         text-overflow: ellipsis;
         max-width: 100%;
         }
         .icon {
         width: 24px;
         height: 24px;
         stroke: #6b7280;                   /* Gray-500 */
         flex-shrink: 0;
         }
         .label {
         font-size: 12px;
         color: #666666;
         font-weight: 500;
         margin: 0;
         }
         .value {
         font-size: 14px;
         font-weight: 500;
         color: #000000;
         margin: 0;
         }
         .section-title {
         font-size: 12px;
         color: #666666;
         font-weight: 500;
         margin-bottom: 0px;
         }
         .description {
         font-size: 12px;
         font-weight: 500;
         color: #000000;
         line-height: 1.6;
         }
         .form-container {
         background-color: #ffffff;
         border: 1px solid #6b7280;
         border-radius: 6px;
         margin-top: 0px;
         }
         .grid {
         display: grid;
         grid-template-columns: repeat(4, 1fr);
         border-collapse: collapse;
         }
         .cell {
         border-bottom: 1px solid #000000;
         border-right: 1px solid #000000;
         padding: 16px 12px;
         }
         .cell-last {
         border-right: 1px solid #000000;
         padding: 16px 12px;
         }
         .cell:nth-child(4n) {
         border-right: none;
         }
         .cell-last:nth-child(4n) {
         border-right: none;
         }
         .label {
         font-size: 12px;
         font-weight: 500;
         color: #666666;
         margin-bottom: 6px;
         }
         .value {
         font-size: 14px;
         font-weight: 500;
         color: #000000;
         }
         .allocation-container {
         border: 1px solid black;
         border-radius: 8px;
         padding: 16px;
         margin-top: 20px;
         }
         .allocation-header {
         display: flex;
         align-items: center;
         border-bottom: 1px solid black;
         padding-bottom: 8px;
         margin-bottom: 16px;
         }
         .allocation-header img {
         width: 16px;
         height: 16px;
         margin-right: 8px;
         }
         .allocation-header h3 {
         font-size: 16px;
         font-weight: 500;
         margin: 0;
         }
         .allocation-grid {
         display: flex;
         flex-wrap: wrap;
         gap: 20px;
         }
         .allocation-details {
         flex: 1 1 50%;
         }
         .allocation-items {
         display: grid;
         grid-template-columns: repeat(3, 1fr);
         gap: 16px;
         font-size: 12px;
         }
         .allocation-item {
         display: flex;
         flex-direction: column;
         word-break: break-word;
         }
         .allocation-item .product-name {
         font-size: 14px;
         font-weight: 500;
         color: #444;
         }
         .allocation-item .percentage {
         font-size: 14px;
         font-weight: 500;
         margin-top: 4px;
         }
         .chart-container {
         display: flex;
         justify-content: flex-end;
         margin-top: 16px;
         }
         .chart-container img {
         width: 160px;
         height: 160px;
         }
         .page-break {
         page-break-before: always;
         break-before: page;
         display: block;
         height: 0; /* No extra space */
         width: 100%;
         content: "";}
         /* Responsive fallback (1 column on small screens) */
         @media print {
         .grid {
         grid-template-columns: repeat(4, 1fr);
         }
         }
         table {
         width: 100%;
         border-collapse: collapse;
         font-size: 10px;
         margin-top: 1rem;
         }
         th, td {
         padding: 0.5rem 1rem;
         }
         /* Header row styling */
         th {
         background-color: #6AA7D3;
         color: white;
         font-weight: bold;
         }
         /* Specific styles for 'Market Price' column header */
         .market-price {
         background-color: #F4D580;
         }
         /* Optional styling for overflow if required */
         .overflow-x-auto {
         overflow-x: auto;
         }
         .bg-light-blue {
         background-color: #92C5EA;
         }
         .bg-product-blue {
         background-color: #C6DFF1;
         }
         .bg-stock-blue {
         background-color: #E6F3FC;
         }
         .bg-summary{
         background-color: #EAEAEA;
         }
         .bg-product-green {
         background-color: #C0E2C1;
         }
         .bg-stock-green {
         background-color: #E7F5E8;
         }
         .bg-light-green {
         background-color: #A9D4AB;
         }
         .bg-off-white {
         background-color: #EAEAEA;
         }
         .text-bold {
         font-weight: bold;
         }
         .text-product{
         font-weight: bold;
         color: #005A9C;
         }
         .text-center {
         text-align: center;
         }
         .text-right {
         text-align: right;
         }
         .font-small {
         font-size: 12px;
         }
         .page-break {
         page-break-before: always;
         }
         .dynamic-table {
         width: 100%;
         margin-top: 0rem;
         border-collapse: separate; /* key to allow border-radius to work */
         border-spacing: 0;
         font-size: 9px;
         margin-bottom: 20px;
         border-radius: 10px;
         overflow: hidden; /* ensures rounded corners are clipped */
         }
         .dynamic-table thead tr:first-child th:first-child {
         border-top-left-radius: 10px;
         }
         .dynamic-table thead tr:first-child th:last-child {
         border-top-right-radius: 10px;
         }
         .dynamic-table th,
         .dynamic-table td {
         padding: 4px 6px;
         border: 1px solid #d1d5db;
         text-align: left;
         vertical-align: top;
         word-break: break-word;
         }  
         .dynamic-table th{
         color: #3730a3;
         background-color: #eef2ff;
         }  
         .dynamic-table td {
         padding: 8px 10px;
         border: 1px solid #e5e7eb;
         background: #ffffff;
         color: #374151;
         }
      </style>
   </head>
   <body>
      <div class="pdf-container">
         <div class="custom-header">
            <div class="logo-container">
               <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
            </div>
            <h2 class="title">Tax Statement</h2>
            <div class="date">${date}</div>
         </div>
         <div class="header">
            <!-- Title Section with Icon -->
            <div class="title-section">
               <img src="${svgGraphBase64}"  alt="Portfolio Icon" class="icon" />
               <div>
                  <h2 class="second-title">Overview</h2>
               </div>
            </div>
         </div>
         <div class="form-container">
            <div class="grid">
               <!-- Cell -->
               <div class="cell">
                  <div class="label">Account Name</div>
                  <div class="value">${taxStatementData.account_name}</div>
               </div>
               <div class="cell">
                  <div class="label">Account Number</div>
                  <div class="value">${taxStatementData.account_number}</div>
               </div>
               <div class="cell">
                  <div class="label">Total taxable income from investment assets</div>
                  <div class="value">${Number(
                    taxStatementData.total_taxable_income
                  )
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
               </div>
               <div class="cell">
                  <div class="label">Date</div>
                  <div class="value">${taxStatementData.date}</div>
               </div>
               <div class="cell">
                  <div class="label">Holdings Valuation at Start of Period</div>
                  <div class="value">$${Number(
                    taxStatementData.holding_valuation_at_start_period
                  )
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
               </div>
               <div class="cell">
                  <div class="label">Holdings Valuation at End of Period</div>
                  <div class="value">$${Number(
                    taxStatementData.holding_valuation_at_end_period
                  )
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
               </div>
               <div class="cell">
                  <div class="label">Portfolio at Start of Period</div>
                  <div class="value">$${Number(
                    taxStatementData.portfolio_at_start_period
                  )
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
               </div>
               <div class="cell">
                  <div class="label">Portfolio at End of Period</div>
                  <div class="value">$${Number(
                    taxStatementData.portfolio_at_end_period
                  )
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
               </div>
               <div class="cell-last">
                  <div class="label">Total Brokerage</div>
                  <div class="value">$${Number(taxStatementData.total_brokerage)
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
               </div>
               <div class="cell-last">
                  <div class="label">Information Service Fees</div>
                  <div class="value">$${Number(
                    taxStatementData.information_service_fee
                  )
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
               </div>
               <div class="cell-last">
                  <div class="label">Estimated Dividends</div>
                  <div class="value">$${Number(
                    taxStatementData.estimated_dividends
                  )
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
               </div>
               <div class="cell-last">
                  <div class="label">Estimated Franking Credits</div>
                  <div class="value">$${Number(
                    taxStatementData.extimated_franking_credits
                  )
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
               </div>
            </div>
         </div>
         ${taxBodyIncome}
         <div class="page-break"></div>
         <div class="header">
            <!-- Title Section with Icon -->
            <div class="title-section">
               <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 17l6-6 4 4 8-8" />
                  <path d="M14 7h7v7" />
               </svg>
               <h2 class="second-title">Realised Capital Gains</h2>
            </div>
         </div>
         ${capitalGainBody}
         <div class="page-break"></div>
         <div class="header">
            <!-- Title Section with Icon -->
            <div class="title-section">
               <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 17l6-6 4 4 8-8" />
                  <path d="M14 7h7v7" />
               </svg>
               <h2 class="second-title">Domestic Dividends</h2>
            </div>
         </div>
         ${domesticDividendBody}
         <div class="page-break"></div>
         <div class="header">
            <!-- Title Section with Icon -->
            <div class="title-section">
               <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 17l6-6 4 4 8-8" />
                  <path d="M14 7h7v7" />
               </svg>
               <h2 class="second-title">International Dividends</h2>
            </div>
         </div>
         ${internationalDividendBody}
         <div class="page-break"></div>
         ${trustDistributionBody}
         <div class="page-break"></div>
         <div class="header">
            <!-- Title Section with Icon -->
            <div class="title-section">
               <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="22" height="22">
                  <line x1="18" y1="20" x2="18" y2="10" />
                  <line x1="12" y1="20" x2="12" y2="4" />
                  <line x1="6" y1="20" x2="6" y2="14" />
               </svg>
               <h2 class="second-title">Estimated Dividends & Distributions</h2>
            </div>
         </div>
         ${estimatedDividendAndDistributionsBody}
         <div class="page-break"></div>
         <div class="header">
            <!-- Title Section with Icon -->
            <div class="title-section">
               <img src="${svgDollarCircleBase64}" alt="Icon" />
               <h2 class="second-title">Transactions</h2>
            </div>
         </div>
         ${transactionBody}
         <div class="page-break"></div>
         <div class="header">
            <!-- Title Section with Icon -->
            <div class="title-section">
               <img src="${svgDollarCircleBase64}" alt="Icon" />
               <h2 class="second-title">Caprock Model Portfolio - Holdings Valuation</h2>
            </div>
         </div>
         ${holdingBody}
         <div class="page-break"></div>
         <div class="header">
            <!-- Title Section with Icon -->
            <div class="title-section">
               <img src="${svgDollarSquareBase64}" alt="Icon" />
               <h2 class="second-title">Brokerage & Info Services</h2>
            </div>
         </div>
         ${brokerageInfoBody}
         <div class="page-break"></div>
         <div class="header">
            <!-- Title Section with Icon -->
            <div class="title-section">
               <img src="${svgTransactionHistoryBase64}" alt="Icon" />
               <h2 class="second-title">Your Cash Account Transaction Details</h2>
            </div>
         </div>
         ${transactionHistoryBody}
      </div>
      </div>
      <!-- Disclaimer -->
      <div style="margin-top: 1.5rem;margin-left: 1.5rem; margin-right: 1.5rem; border-bottom: 1px solid #000; padding-bottom: 0.5rem;">
         <h3 style="display: flex; align-items: center; font-size: 1rem; font-weight: 500; color: #000; margin: 0;">
            <img src="${svgInfoCircleBase64}" alt="Info Icon" style="width: 20px; height: 20px; margin-right: 0.5rem;" />
            <span>Important Information</span>
         </h3>
         <p style="font-size: 0.775rem; color: #000; font-weight: 500; line-height: 1.6; margin-top: 0.5rem;">
            This document contains information relating to income distributed to you in respect of your investments in the Caprock Merchant Managed Account Platform (MAP).  The information may be relevant in preparing your tax return for the financial year and should be retained with your tax or other financial records. If you are an individual investor, you can refer to the Tax Return References on page one to assist with preparing your tax return.  If you hold your investment in a different capacity, these references will not be relevant to you.</br></br> 
            Where you received distributions in respect of other investments outside of MAP during the financial year, you will likely need to account for these in your tax return as well.</br></br>
            The information is current as at the date of this document.</br></br>
         </p>
      </div>
      <!-- Disclaimer -->
      <div style="margin-top: 1.5rem;margin-left: 1.5rem; margin-right: 1.5rem; border-bottom: 1px solid #000; padding-bottom: 0.5rem;">
         <h3 style="display: flex; align-items: center; font-size: 1rem; font-weight: 500; color: #000; margin: 0;">
            <img src="${svgInfoCircleBase64}" alt="Info Icon" style="width: 20px; height: 20px; margin-right: 0.5rem;" />
            <span>Disclaimer</span>
         </h3>
         <p style="font-size: 0.775rem; color: #000; font-weight: 500; line-height: 1.6; margin-top: 0.5rem;">
            This document should not be construed as legal, financial or tax advice and cannot be relied upon as such.  Recipients should read the document in its entirety and seek independent legal, financial and / or tax advice about their investments in the MAP, including their obligations under relevant taxation laws and the preparation of their income tax return or other documentation, having regard to their own personal circumstances.</br></br>
            Caprock Merchant Pty Limited, its related entities and their respective directors, officers, employees, representatives, advisers and associates, are not liable nor responsible whatsoever for any loss, claims or damages howsoever arising, directly or indirectly, in relation to or in connection with the use of this document or its contents.
         </p>
      </div>
   </body>
</html>`;
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Caprock Merchant Tax Statement - ${formattedDate}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHiddenTaxReport(false);
  };
  // Download valuation report
  const downloadValuationReport = useCallback(
    debounce(() => {
      getPopData();
    }, 1000), // Debounce time
    [factSheetFileName, investmentId] // Dependencies
  );
  const downloadTaxStatementReport = useCallback(
    debounce(() => {
      getTaxStatementData();
    }, 1000), // Debounce time
    [] // Dependencies
  );
  useEffect(() => {
    if (isHiddenReport == true) {
      handleDownloadValuationPDF();
    }
  }, [isHiddenReport]);
  // End here
  useEffect(() => {
    if (isHiddenTaxReport == true) {
      handleDownloadTaxPDF();
    }
  }, [isHiddenTaxReport]);

  function createTableHeader(columns) {
    const thead = document.createElement("thead");

    // Create thead
    const headRow = document.createElement("tr");
    columns.forEach((col) => {
      const th = document.createElement("th");
      th.textContent = col.label;
      if (col.width) th.style.width = col.width;
      if (col.minWidth) th.style.minWidth = col.minWidth;
      headRow.appendChild(th);
    });
    thead.appendChild(headRow);
    return thead;
  }
  function createTableBody(data, columns) {
    const body = document.createElement("tbody");

    data.forEach((row) => {
      const tr = document.createElement("tr");
      tr.classList.add("tbody-tr");

      tr.innerHTML = columns
        .map(({ key, formatter }) => {
          let value = row[key];
          if (formatter) {
            value = formatter(value, row);
          }
          return `<td>${value !== undefined ? value : ""}</td>`;
        })
        .join("");

      body.appendChild(tr);
    });

    return body;
  }

  const handleDownloadPDFTable = async () => {
    const columns = [
      {
        label: "Date",
        key: "created_at",
        formatter: (val) => formatDateList(val),
      },
      { label: "Transaction", key: "type" },
      {
        label: "Amount",
        key: "amount",
        formatter: (val) =>
          `$${val
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
      },
      { label: "Transaction Status", key: "status" },
      { label: " Stock Status", key: "stock_status" },
    ];
    const date = new Date().toLocaleString();
    const tableHeadElement = createTableHeader(columns);
    const tableHeader = tableHeadElement.outerHTML;
    const tableBodyElement = createTableBody(pdfData, columns);
    const tableBody = tableBodyElement.outerHTML;
    const fullHtml = `
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8" />
            <style>
            @page {
      size: A4 landscape;
      margin: 0;
    }
      html, body {
              margin: 0;
              padding: 0;
                        font-family:sans-serif;
      overflow: auto;  /* Ensure content can overflow */
    
              height: 100%; /* Ensure the body fills the entire height */
            }        .pdf-container {
                max-width: 100% !important;
                margin: 20px;
              }
              tr {
                page-break-inside: avoid !important;
                break-inside: avoid !important;
              }
      
              .custom-header {
                position: relative;
                display: flex;
                justify-content: space-between;
                background-color: #ffffff;
                padding-top: 10px; /* Ensures no padding at the top */
              }
      
              .logo-container {
                display: flex;
                align-items: center;
              }
      
              .logo {
                width: 96px; /* Tailwind w-24 = 6rem = 96px */
                max-width: 150px;
                height: auto;
                object-fit: contain;
                margin-right: 1rem;
              }
      
              .title {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                font-size: 1.125rem; /* Tailwind text-lg */
                font-weight: 500;    /* Tailwind font-medium */
                padding: 0;          /* Remove any padding */
                margin: 0;           /* Remove any margin */
              }
      
              .date {
                font-size: 0.875rem;  /* Tailwind text-sm */
                font-weight: 500;
                color: #000000;
                padding-bottom: 16px;
              }
    
      
    .page-break {
             page-break-before: always;
      break-before: page;
      display: block;
      height: 0; /* No extra space */
      width: 100%;
      content: "";}
          table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;
        }
    
        thead {
          font-size: 10px;
          color: #6B7280; /* Tailwind text-labelColour equivalent */
        }
    
        th {
          border-bottom: 1px solid #000;
          padding: 8px;
          text-align: left;
        }
              td {
          padding: 6px;
          font-size: 10px;
          vertical-align: middle;
          text-align: left;
        }
          .tbody-tr{
                      background-color: #F9F9F9;
                      margin-bottom: 10px;
    
          }
            </style>
          </head>
          <body>
         <div class="pdf-container">
            <div class="custom-header">
              <div class="logo-container">
                <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
              </div>
              <h2 class="title">Transaction History</h2>
              <div class="date">${date}</div>
            </div>
            
      <table id="dynamic-table">
      ${tableHeader}
        ${tableBody}
    
      </table>
        
          </div> 
    
               </body>
        </html>
      `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Transaction History-${formattedDate}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHiddenTable(false);
  };
  useEffect(() => {
    if (isHiddenTable == true) {
      handleDownloadPDFTable();
    }
  }, [isHiddenTable]);
  useEffect(() => {
    if (isHiddenInvestorList == true) {
      handleDownloadInvestorListPDFTable();
    }
  }, [isHiddenInvestorList]);
  const downloadExcelReportTransaction = async () => {
    const token = localStorage.getItem("jwtToken");
    let apiUrl = "";

    if (selectedDates.length == 2) {
      apiUrl = `${BASE_URL}/v1/user/${customerId}/my-investment/${investmentId}/transactions/export/excel?page=${currentPage}&size=1000&search=${searchQuery}&start_date=${formatDateForFilter(
        selectedDates[0]
      )}&end_date=${formatDateForFilter(selectedDates[1])}`;
    } else {
      apiUrl = `${BASE_URL}/v1/user/${customerId}/my-investment/${investmentId}/transactions/export/excel?page=${currentPage}&size=1000&search=${searchQuery}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          // Example: redirect to login page
          // window.location.href = "/login";

          // Or throw a custom error
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const downloadPDFTable = useCallback(
    debounce(async (e, option) => {
      if (option.value == "excel") {
        setLoading(true);
        try {
          const csvBlob = await downloadExcelReportTransaction();
          const url = window.URL.createObjectURL(csvBlob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `Transaction History-${formattedDate}.xlsx`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          showToast(err.message, "error");
        } finally {
          setIsOpen(false);
          setTimeout(function () {
            setLoading(false); // Ensure `loading` is false first
          }, 100);
        }
      }
      if (option.value == "pdf") {
        try {
          let apiUrl = "";
          if (selectedDates.length == 2) {
            apiUrl = `/v1/user/${customerId}/my-investment/${investmentId}/transactions?page=${currentPage}&size=1000&search=${searchQuery}&start_date=${formatDateForFilter(
              selectedDates[0]
            )}&end_date=${formatDateForFilter(selectedDates[1])}`;
          } else {
            apiUrl = `/v1/user/${customerId}/my-investment/${investmentId}/transactions?page=${currentPage}&size=1000&search=${searchQuery}`;
          }
          const response = await GetAPIcalls(apiUrl);

          if (response.status == 200) {
            if (response.data == null) {
              setPdfData([]);
              setIsHiddenTable(false);
              setLoading(false);
              showToast("No data available to generate the report.", "error");
            } else {
              setPdfData(response.data.transactions);
              setIsHiddenTable(true);
            }
          } else {
            if (response.status === 401) {
              localStorage.removeItem("jwtToken");
              navigate("/login");
            }
            setPdfData([]);
          }
        } catch (err) {
          if (err.status === 401) {
            localStorage.removeItem("jwtToken");
            navigate("/login");
          }
          setPdfData([]);
          showToast(err.message, "error");
        }
      }
    }, 1000), // Debounce time
    [filter, searchQuery, selectedDates] // Dependencies
  );
  // end here
  useEffect(() => {
    if (selectedDates.length === 2) {
      const formattedRange = `${formatDate(
        selectedDates[0].toLocaleDateString()
      )} — ${formatDate(selectedDates[1].toLocaleDateString())}`;
      setSelectedRange(formattedRange);
    }
  }, [selectedDates]);
  // Handle quick filter selection
  const handleQuickFilter = (filter) => {
    const today = new Date();
    let startDate, endDate;

    if (filter === "this_week") {
      // Adjust to start from Monday
      const dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1; // Adjust for Monday as first day
      startDate = new Date(today.setDate(today.getDate() - dayOfWeek));
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6); // End of the week
    } else if (filter === "last_week") {
      const dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1; // Adjust for Monday as first day
      endDate = new Date(today.setDate(today.getDate() - dayOfWeek - 1)); // End of last week
      startDate = new Date(endDate);
      startDate.setDate(endDate.getDate() - 6); // Start of last week
    } else if (filter === "this_month") {
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    } else if (filter === "this_year") {
      startDate = new Date(today.getFullYear(), 0, 1);
      endDate = new Date(today.getFullYear(), 11, 31);
    } else if (filter === "last_year") {
      startDate = new Date(today.getFullYear() - 1, 0, 1);
      endDate = new Date(today.getFullYear() - 1, 11, 31);
    } else if (filter === "custom") {
      // Custom filter: enable calendar range selection and reset dates
      setSelectedDates([]);
      setSelectedRange("Select Date Range");
      setQuickFilter(filter);
      return;
    } else if (filter === "") {
      // Custom filter: enable calendar range selection and reset dates
      setSelectedDates([]);
      setSelectedRange("Select Date Range");
      setQuickFilter(filter);
      return;
    }
    setQuickFilter(filter);
    setSelectedDates([startDate, endDate]);
    setSelectedRange(
      `${startDate.toLocaleDateString()} — ${endDate.toLocaleDateString()}`
    );
    setCurrentPage(1);
  };
  const handleSelect = (option) => {
    setSelected(option.label);
    setIsOpen(false);
  };

  const fetchStocks = async (id) => {
    let toastMessage = null;
    try {
      setIsLoadingPortfolio(true);
      const response = await GetAPIcalls(
        `/v1/external-stocks/strategy-recommendation/${customerId}?page=${currentPageStrategies}&size=${showRecordsStrategies}`
      );
      if (response.status == 200) {
        setPortfolioAccounttableData(response.data.data);
        setTotalPageStrategiesStrategies(response.data.pagination.total_pages);
        setTotalCountStrategies(response.data.pagination.total_strategies);
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      setPortfolioAccounttableData([]);
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setTimeout(() => {
        setIsLoadingPortfolio(false);
        if (toastMessage) {
          showToast(toastMessage.message, toastMessage.type);
        }
      }, 300); // Small delay if needed
    }
  };
  const labelsLine = rawData.map((item) => {
    const date = new Date(item.date); // Parse the date
    return date; // Return Date object (Chart.js can parse Date objects)
  });

  const optionsLine = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        mode: "index",
        intersect: false,
        backgroundColor: "#111827",
        titleColor: "#fff",
        borderColor: "#374151",
        borderWidth: 1,
        padding: 12,
        displayColors: false, // hoverRadiusHide colored dots
        callbacks: {
          title: (tooltipItems) => {
            const timestamp = tooltipItems[0].parsed.x; // <-- reliable timestamp
            const date = new Date(timestamp);
            if (selectedFilter === "1M" || selectedFilter === "3M") {
              const day = date.getDate().toString().padStart(2, "0");
              const month = date.toLocaleDateString("en-US", {
                month: "short",
              });
              const year = date.getFullYear();
              return `${day} ${month} ${year}`;
            } else {
              const month = String(date.getMonth() + 1).padStart(2, "0");
              const year = date.getFullYear();
              return `${month}/${year}`;
            }
          },
          label: (tooltipItem) => {
            const index = tooltipItem.dataIndex;
            const value = `$${tooltipItem.raw
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
            const isUpdated = rawData[index]?.version_changed;

            return isUpdated ? `${value} (SAA updated)` : value;
          },
          labelTextColor: function (context) {
            const index = context.datasetIndex;
            const index2 = context.dataIndex;
            const isUpdated = rawData[index2]?.version_changed;
            return isUpdated
              ? ["#0D9488", "#DC4646", "#34C046"][index]
              : ["#3047EC", "#DC4646", "#34C046"][index];
          },
        },
      },
      legend: { display: false },
    },
    scales: {
      x: {
        type: "time", // Ensure the x-axis uses time scale
        time: {
          unit:
            selectedFilter === "1M" || selectedFilter === "3M"
              ? "day"
              : "month",
          tooltipFormat:
            selectedFilter === "1M" || selectedFilter === "3M"
              ? "MMM d (EEE)"
              : "MMM yyyy",
        },
        grid: { drawOnChartArea: false, drawTicks: false },
        ticks: {
          display: true,
          color: "black",

          callback: function (value) {
            const date = new Date(value);

            if (selectedFilter === "1M" || selectedFilter === "3M") {
              const day = date.getDate().toString().padStart(2, "0");
              const month = date.toLocaleDateString("en-US", {
                month: "short",
              });

              return [day, month];
            } else {
              const month = date.toLocaleDateString("en-US", {
                month: "short",
              }); // e.g., Jan
              const year = date.getFullYear();
              return [month, year];
            }
          },
          font: {
            size: 12, // Adjust size to fit the labels properly
          },
          maxRotation: 0,
          minRotation: 0,
        },
        border: { color: "black" },
        afterFit: function (scale) {
          scale.height = 60; // Adjust the height to ensure space for two lines
        },
      },
      y: {
        grid: {
          drawOnChartArea: true, // Show grid lines on the chart area
          drawTicks: false, // Optionally hide ticks on grid lines
          color: "rgba(0, 0, 0, 0.1)", // Set the color of the grid lines (light gray)
          lineWidth: 1, // Set the line width of the grid lines
        },
        ticks: {
          callback: (value) => `${value.toFixed(2)}`,
          color: "black",
          padding: 10, // Add spacing for Y-axis labels
        },
        beginAtZero: false, // Optional: prevent starting at zero
        min: 0, // Adjust this value to add more space above the border
        offset: true, // Add extra space between the border and the graph
        border: { display: false },
      },
    },
  };
  const dataLine = {
    labels: labelsLine,
    datasets: [
      {
        label: "Price",
        data: stockPrices,
        borderColor: "#3047EC",
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) {
            return null; // Wait until the chart is fully rendered
          }

          const gradient = ctx.createLinearGradient(
            0,
            chartArea.top,
            0,
            chartArea.bottom
          );
          gradient.addColorStop(0, "rgba(74, 144, 226, 0.1)"); // Light blue at the top
          gradient.addColorStop(1, "white"); // White at the bottom

          return gradient;
        },
        tension: 0.4,
        pointRadius: rawData.map((item) => (item.version_changed ? 7 : 4)),
        pointHoverRadius: rawData.map((item) => (item.version_changed ? 9 : 6)),
        pointBackgroundColor: rawData.map((item) =>
          item.version_changed ? "#ffffff" : "#3047EC"
        ),
        pointBorderColor: rawData.map((item) =>
          item.version_changed ? "#0D9488" : "#3047EC"
        ),
        pointBorderWidth: rawData.map((item) => (item.version_changed ? 6 : 3)),
        fill: false,
      },
      {
        label: "Combine indices",
        data: combineIndex,
        borderColor: "#DC4646",
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) {
            return null; // Wait until the chart is fully rendered
          }

          const gradient = ctx.createLinearGradient(
            0,
            chartArea.top,
            0,
            chartArea.bottom
          );
          gradient.addColorStop(0, "rgba(220, 70, 70, 0.3)"); // Light red (same as border, low opacity)
          gradient.addColorStop(1, "rgba(220, 70, 70, 0)");

          return gradient;
        },
        tension: 0.4,
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBackgroundColor: "#DC4646",
        fill: true,
      },
    ],
  };
  useEffect(() => {
    if (historyChartRef.current && dataLine?.datasets?.[0]?.data?.length > 0) {
      setTimeout(() => {
        const chartInstance = historyChartRef.current;
        if (chartInstance?.toBase64Image) {
          setHistoryChartImage(chartInstance.toBase64Image());
        }
      }, 1000); // Ensures chart is fully rendered
    }
  }, [dataLine]);

  useEffect(() => {
    if (filter === "view") {
      dispatch(resetDocumentId());
      getInvestmentView();
    }
    if (filter === "details") {
      fetchDetailData();
      getDetails();
    }
    if (filter === "manage-funds") {
      fetchTrancationHistory();
      getInvestmentView();
    }
  }, [
    filter,
    showRecords,
    searchQuery,
    investmentId,
    currentPage,
    selectedDates,
    customerId,
  ]);
  useEffect(() => {
    if (filter === "details") {
      fetchHistoricalGraphData();
    }
  }, [filter, selectedFilter, investmentId]);
  useEffect(() => {
    if (filter === "manage-funds") {
      fetchManageFunds();
    }
    if (filter === "manage-funds" && investmentId == -1) {
      fetchStocks();
    }
  }, [filter, investmentId, customerId]);

  useEffect(() => {
    if (filter === "manage-funds" && investmentId == -1) {
      fetchStocks();
    }
  }, [filter, investmentId, showRecordsStrategies, currentPageStrategies]);
  useEffect(() => {
    if (filter === "manage-funds") {
      fetchSpecificGraphData();
      getAllInvestmentDividend();
    }
  }, [
    filter,
    investmentId,
    customerId,
    selectedFilterHour,
    balanceChangeFilterValue,
  ]);

  const formatDate = (dateString) => {
    const date = new Date(dateString); // Convert string to Date object
    const day = String(date.getDate()).padStart(2, "0"); // Get day with leading zero
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Get month (0-indexed) with leading zero
    const year = date.getFullYear(); // Get full year

    return `${day}/${month}/${year}`; // Format as DD/MM/YYYY
  };
  const options = [
    { value: "pdf", label: "PDF" },
    { value: "excel", label: "Excel" },
  ];
  const formatDateList = (dateString) => {
    const [datePart] = dateString.split(" "); // Extract the date portion
    const [day, month, year] = datePart.split("/"); // Split into day, month, and year
    return `${day}/${month}/${year}`;
  };
  const fetchDetailData = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/user/${customerId}/my-investment/${investmentId}/details`
      );

      if (response.status == 200) {
        setinvestmentManagerNameView(response.data.factsheet.manager_name);
        setdateCreated(formatDateList(response.data.factsheet.date));
        setstrategyTypeView(response.data.factsheet.strategy_type);
        setGrowth(response.data.factsheet.growth);
        setDefensive(response.data.factsheet.defensive);
        setFundObjectives(response.data.factsheet.fund_objective_and_process);
        setinvestmentProductName(
          response.data.factsheet.investment_product_name
        );
        setpastPerformance(response.data.past_performance);
        setCopyright(response.data.copy_rights);
        setDisclaimer(response.data.disclaimer);
        // current allocation
        setExistingCategories(response.data.current_target_allocations);

        //allocation graph
        setfilteredGraphdata(response.data.product_allocations);
        // setrawData(response.data.historic_prices);
        // const stockPrices = response.data.historic_prices.map(
        //   (item) => item.price
        // );
        // setStockprices(stockPrices);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const fetchSpecificData = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/investment-portfolio/my-investment-performance`;
    const bodyData = {
      portfolio_id: investmentId,
      time_interval: selectedFilterHour.toUpperCase(),
      user_id: customerId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const fetchSpecificGraphData = useCallback(
    debounce(async (e) => {
      setIsLoadingGraph(true);
      let toastMessage = null;
      try {
        const response = await fetchSpecificData();

        if (response.status == 200) {
          setPerformanceGraph(response.data.performance_data);
        } else {
          if (response.status === 401) {
            localStorage.removeItem("jwtToken");
            navigate("/login");
          }
          if (response.status === 400) {
            toastMessage = { message: response.message, type: "error" };
          }
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
      } finally {
        // Show toast after loading is false
        setIsLoadingGraph(false);

        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [selectedFilterHour, customerId, investmentId] // Dependencies
  );

  const fetchHistoricalData = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/user/${customerId}/my-investment/portfolio/historic-performance`;
    const bodyData = {
      portfolio_id: investmentId,
      time_interval: selectedFilter,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const fetchHistoricalGraphData = useCallback(
    debounce(async (e) => {
      setIsLoadingGraph(true);
      let toastMessage = null;
      try {
        const response = await fetchHistoricalData();

        if (response.status == 200) {
          setrawData(response.data.graph_data);
          const stockPrices = response.data.graph_data.map(
            (item) => item.total_price
          );
          const combineIndices = response.data.combined_index_graph.map(
            (item) => item.value
          );
          setCombineIndex(combineIndices);
          setStockprices(stockPrices);
        } else {
          if (response.status === 401) {
            localStorage.removeItem("jwtToken");
            navigate("/login");
          }
          if (response.status === 400) {
            toastMessage = { message: response.message, type: "error" };
          }
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
      } finally {
        // Show toast after loading is false
        setIsLoadingGraph(false);

        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [selectedFilter, customerId] // Dependencies
  );
  const fetchManageFunds = async () => {
    setIsLoading(true);

    try {
      const response = await GetAPIcalls(
        `/v1/user/${customerId}/my-investment/${investmentId}/manage-funds`
      );

      if (response.status == 200) {
        const InvestmentportfolioData = [];
        response.data.investment_portfolios.forEach((profile) => {
          InvestmentportfolioData.push({
            value: profile.id,
            label: "Caprock Model Portfolio -" + profile.name,
          });
        });
        setInvestmentPortfolioData(InvestmentportfolioData);
        setManageFundData(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const formatDateForFilter = (dateString) => {
    const date = new Date(dateString);

    // Extract year, month, and date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 since months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`; // Format as yyyy-dd-mm
  };
  const fetchTrancationHistory = async () => {
    setIsLoadingHistory(true);
    try {
      let apiUrl = "";
      if (selectedDates.length == 2) {
        apiUrl = `/v1/user/${customerId}/my-investment/${investmentId}/transactions?page=${currentPage}&size=${showRecords}&search=${searchQuery}&start_date=${formatDateForFilter(
          selectedDates[0]
        )}&end_date=${formatDateForFilter(selectedDates[1])}`;
      } else {
        apiUrl = `/v1/user/${customerId}/my-investment/${investmentId}/transactions?page=${currentPage}&size=${showRecords}&search=${searchQuery}`;
      }
      const response = await GetAPIcalls(apiUrl);

      if (response.status == 200) {
        if (response.data == null) {
          setTransactionHistoryData([]);
          setCurrentPage(1);
          settotalPages(0);
          settotalCount(0);
        } else {
          setTransactionHistoryData(response.data.transactions);
          setCurrentPage(response.data.page);
          settotalPages(response.data.total_pages);
          settotalCount(response.data.total_count);
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setTransactionHistoryData([]);
          setCurrentPage(1);
          settotalPages(0);
          settotalCount(0);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      setTransactionHistoryData([]);
      setCurrentPage(1);
      settotalPages(0);
      settotalCount(0);
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoadingHistory(false);
      }, 100);
    }
  };
  const getInvestmentView = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/user/${customerId}/my-investment/${investmentId}/summary`
      );

      if (response.status == 200) {
        setRefId(response.data.basic_details.ref_code);
        setstrategyType(response.data.basic_details.strategy_type);
        setRiskProfile(response.data.basic_details.risk_profile);
        setinvestmentType(response.data.basic_details.investment_type);
        if (response.data.basic_details.investment_manager != null) {
          setInvestmentManagerNamefromAPI(
            response.data.basic_details.investment_manager.name
          );
          setmanagerFees(
            response.data.investment_details.investment_manager_fee
          );
        }
        //asset manager
        if (response.data.basic_details.asset_manager != null) {
          setAssetManagerNamefromAPI(
            response.data.basic_details.asset_manager.name
          );
          setassetManagerFees(
            response.data.investment_details.asset_manager_fee
          );
        }
        //Advisor
        if (response.data.basic_details.advisor != null) {
          setadvisorIdfromAPI(response.data.basic_details.advisor.name);
          setadvisorFees(response.data.investment_details.advisor_fee);
        }
        //subadvisor
        if (response.data.basic_details.sub_advisor != null) {
          setSubadvisorIdfromAPI(response.data.basic_details.sub_advisor.name);
          setsubadvisorFees(response.data.investment_details.sub_advisor_fee);
        }
        setFundObjectives(
          response.data.basic_details.fund_objective_and_process
        );
        setinvestmentProductName(
          response.data.investment_details.investment_product_name
        );
        setpreSelectedInvestmentFilter({
          value: investmentId,
          label:
            "Caprock Model Portfolio -" +
            response.data.investment_details.investment_product_name,
        });
        setriskRating(response.data.investment_details.risk_rating);
        setGrowth(response.data.investment_details.growth);
        setDefensive(response.data.investment_details.defensive);
        setInvestments(response.data.investment_details.investment_tags);
        setminimumInvestedAmount(
          response.data.investment_details.minimum_investment
        );
        setstrategyDate(
          formatDateList(
            response.data.investment_details.strategy_creation_date
          )
        );

        setsmaFees(response.data.investment_details.sma_fee_percentage);
        for (let i = 0; i < response.data.documents.length; i++) {
          dispatch(addDocumentId(response.data.documents[i]));
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };

  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const postHoldingDataAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/user/my-investment/user-holding-graphs`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const bodyData = {
      portfolio_id: investmentId,
      user_id: Number(customerId),
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getPopData = async () => {
    try {
      const response = await postHoldingDataAPI();
      if (response.status == 200) {
        setholdingValuationData(response.data);
        setRawDatapdf(response.data.product_allocations);
        setIsHiddenReport(true);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setholdingValuationData([]);
          showToast(response.message, "error");
          setTimeout(function () {
            setLoading(false);
          }, 100);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setTimeout(function () {
        setLoading(false);
      }, 100);
    } finally {
    }
  };
  const postTaxDataAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/report/tax-report-data`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const bodyData = {
      portfolio_id: investmentId,
      user_id: Number(customerId),
      year: new Date().getFullYear(),
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getTaxStatementData = async () => {
    // setTaxStatementData({
    //   account_name: "X Account",
    //   account_number: null,
    //   total_holding_value: "0.0",
    //   total_taxable_income: "0.0",
    //   date: "06/08/2025 06:35 AM AEST",
    //   holding_valuation_at_start_period: "0.0",
    //   holding_valuation_at_end_period: "0.0",
    //   portfolio_at_start_period: "21049.43",
    //   portfolio_at_end_period: "21049.43",
    //   total_brokerage: 0,
    //   information_service_fee: 0,
    //   estimated_dividends: 0,
    //   extimated_franking_credits: 0,
    // });
    // setIsHiddenTaxReport(true);
    try {
      const response = await postTaxDataAPI();
      if (response.status == 200) {
        if (response.data) {
          setTaxStatementData(response.data);
          setIsHiddenTaxReport(true);
        } else {
          setTaxStatementData([]);
          showToast(response.message, "error");
          setTimeout(function () {
            setLoading(false);
          }, 100);
          setIsHiddenTaxReport(false);
        }
      } else {
        if (response.status === 400) {
          setTaxStatementData([]);
          showToast(response.message, "error");
          setTimeout(function () {
            setLoading(false);
          }, 100);
        }
        setIsHiddenTaxReport(false);
      }
    } catch (err) {
      showToast(err.message, "error");
      setTimeout(function () {
        setLoading(false);
      }, 100);
      setTaxStatementData([]);

      setIsHiddenTaxReport(false);
    } finally {
    }
  };
  //Graphs
  const filteredDataGraph = allocationGraphData.filter(
    (item) => item.current_allocation > 0
  );

  // Prepare labels and allocations for the donut chart
  let labels = filteredDataGraph.map((item) => item.product_name);
  let allocations = filteredDataGraph.map((item) =>
    item.current_allocation.toFixed(2)
  );

  // Dynamic colors for each slice
  let colors = filteredDataGraph.map((item) => "#" + item.color);

  // Donut chart data configuration
  let donutData = {
    labels: labels, // Product names
    datasets: [
      {
        label: "Allocation (%)",
        data: allocations, // Allocation values
        backgroundColor: colors, // Dynamic colors
        borderWidth: 0,
      },
    ],
  };

  // Donut chart options
  const donutOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // Disable legend on the donut chart
      },
      tooltip: {
        enabled: false, // Disable the default tooltip
      },
    },
    cutout: "65%", // Creates the hole in the center for the donut chart
  };
  const getDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/user/${customerId}/my-investment/${investmentId}/report-data`
      );
      if (response.status == 200) {
        setDetails(response.data);
        setfactsheetFileName(response.data.basic_details.name);
        setRawDatapdf(response.data.product_allocations);
        setRawDatahistorypdf(response.data.performance_graph.data);
        const stockPrices = response.data.performance_graph.data.map(
          (item) => item.value
        );
        setStockpricesPdf(stockPrices);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      showToast(err.message, "error");
    } finally {
    }
  };
  const getSelfManagedDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/user/${customerId}/my-investment/${investment_id}/report-data`
      );
      if (response.status == 200) {
        setDetails(response.data);
        setfactsheetFileName(response.data.basic_details.name);
        setRawDatapdf(response.data.product_allocations);
        setRawDatahistorypdf(response.data.performance_graph.data);
        const stockPrices = response.data.performance_graph.data.map(
          (item) => item.value
        );
        setStockpricesPdf(stockPrices);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        DateCalendarRef.current &&
        !DateCalendarRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
      if (DownloadRef.current && !DownloadRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  const handleContinue = () => {
    setLoading(true);
    downloadPDF();
  };
  const downloadExcelReport = async () => {
    const token = localStorage.getItem("jwtToken");

    try {
      const response = await fetch(
        `${BASE_URL}/v1/investment-portfolio/factsheet/${investment_id}/export/excel?period=${selectedFilter}&user_id=${customerId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          // Example: redirect to login page
          // window.location.href = "/login";

          // Or throw a custom error
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const handleExcel = async () => {
    setLoading(true);
    try {
      const csvBlob = await downloadExcelReport();
      const url = window.URL.createObjectURL(csvBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Factsheet - Caprock Model Portfolio - ${investmentProductName}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setLoading(false); // Ensure `loading` is false first
      }, 100);
    }
  };
  const handleContinueHoldingReport = () => {
    setLoading(true);
    downloadValuationReport();
  };
  const downloadExcelReportHoldingValuation = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/user/my-investment/user-holding-graphs/export/excel`;
    const bodyData = {
      portfolio_id: investmentId,
      user_id: Number(customerId),
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const handleExcelHoldingReport = async () => {
    setLoading(true);
    try {
      const csvBlob = await downloadExcelReportHoldingValuation();
      const url = window.URL.createObjectURL(csvBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Holding Valuation -${formattedDate}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setLoading(false); // Ensure `loading` is false first
      }, 100);
    }
  };
  const handleContinueTaxStatementReport = () => {
    setLoading(true);
    downloadTaxStatementReport();
  };
  const downloadExcelReportTax = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/report/tax-report`;
    const bodyData = {
      portfolio_id: investmentId,
      user_id: Number(customerId),
      year: new Date().getFullYear(),
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const handleExcelTaxStatementReport = async () => {
    setLoading(true);
    try {
      const csvBlob = await downloadExcelReportTax();
      const url = window.URL.createObjectURL(csvBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Caprock Merchant Tax Statement - ${formattedDate}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setLoading(false); // Ensure `loading` is false first
      }, 100);
    }
  };
  return (
    <div className="pr-4">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="">
        <div className="pt-6 pr-4 flex-wrap pt-4  text-xs md:text-sm overflow-x-auto items-center">
          <div className="flex mb-2">
            <button
              onClick={() => {
                setFilter("view");
                dispatch(setTabSelfRedux("view"));
              }}
              className={`lg:px-4 px-2 py-2 rounded-l-xl border-r border-gray-100 ${
                filter === "view"
                  ? "bg-black text-white"
                  : "bg-white text-black"
              }`}
            >
              Portfolio Summary
            </button>
            <button
              onClick={() => {
                setFilter("details");
                dispatch(setTabSelfRedux("details"));
              }}
              className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
                filter === "details"
                  ? "bg-black text-white"
                  : "bg-white text-black"
              }`}
            >
              Details
            </button>
            <button
              onClick={() => {
                setFilter("manage-funds");
                dispatch(setTabSelfRedux("manage-funds"));
              }}
              className={`px-4 py-2 rounded-r-xl ${
                filter === "manage-funds"
                  ? "bg-black text-white"
                  : "bg-white text-black"
              }`}
            >
              Manage Investment
            </button>
          </div>
        </div>
        {filter == "details" && (
          <div className="w-full p-4 bg-white rounded-lg shadow-lg lg:min-w-[78vw] lg:max-w-[80vw]">
            <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
              <h1 className="text-lg font-medium mb-2">
                Fact Sheet:
                <span className="text-[#888888]">
                  {" "}
                  Caprock Model Portfolio - {investmentProductName}
                </span>
              </h1>
            </div>
            <div className="overflow-x-auto border-b mb-4">
              <table className="w-full h-full border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2 ">
                {/* Table Header */}
                <thead className="text-[#8C8C8C]  rounded-md mb-2 text-sm">
                  <tr className="border border-[#EDEDED]">
                    {secondheaders.map((header, index) => (
                      <th
                        key={header}
                        className={`
                            cursor-pointer w-40   font-medium px-4 py-2 mb-5  text-left
                            ${
                              index === 0
                                ? "border-t rounded-tl-md rounded-bl-md border-b border-l border-[#EDEDED]" // Center column: Top and Bottom border only
                                : ""
                            }
                                ${
                                  index === 1 || index === 2 || index === 3
                                    ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                    : ""
                                }
                              ${
                                index === 4
                                  ? "border-t border-b rounded-tr-md rounded-br-md border-r  border-[#EDEDED]" // Center column: Top and Bottom border only
                                  : ""
                              }
                          `}
                      >
                        <div class="flex items-center">
                          <span>{header}</span>
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>

                {/* Table Body */}
                <tbody className="text-sm mt-6  font-medium text-black">
                  <tr className="mb-2 bg-[#F9F9F9]">
                    <td className="px-4 py-4 w-1/2 text-ellipsis  overflow-hidden whitespace-nowrap">
                      {investmentManagerNameView}
                    </td>

                    {/* Dropdown Button */}
                    <td className="px-4 py-4 relative">{dateCreated}</td>

                    <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                      {strategyTypeView}
                    </td>

                    <td className="px-4 py-4 text-left text-ellipsis  overflow-hidden whitespace-nowrap">
                      {growth}
                    </td>

                    <td className="px-4 py-4 text-left">{defensive}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="mt-6 mb-4 px-4">
              <label
                htmlFor="fundObjective"
                className="block mb-1 text-md font-semibold text-black"
              >
                Fund Objective & Process
              </label>
              <div
                dangerouslySetInnerHTML={{ __html: fundObjectives }}
                className="text-sm"
              ></div>
            </div>
          </div>
        )}
        {filter == "details" && (
          <div className="bg-white w-full mt-6 p-6 px-8 shadow-md rounded-md">
            {/* Header */}
            <h2 className="text-lg font-semibold font-semibold mb-4">
              Current Target Allocation
            </h2>

            {/* Table Header */}
            <div className="mb-2">
              <table className="w-full table-auto border-collapse">
                <thead>
                  <tr className="flex justify-between border py-2 rounded-md">
                    <th className="text-sm pl-14 font-medium text-[#8C8C8C] text-left flex-1">
                      Asset Category
                    </th>

                    <th className="text-sm pr-12 font-medium text-[#8C8C8C]  text-right flex-1">
                      Allocation (%)
                    </th>
                  </tr>
                </thead>
                <tbody>{/* Table Body Rows */}</tbody>
              </table>
            </div>

            {existingCategories.map((category, categoryIndex) => (
              <div key={category.category} className="mb-6">
                <div
                  className={`flex items-center flex-wrap justify-between p-4  rounded-md ${
                    category.category === "Defensive"
                      ? "bg-[#A9D4AB]"
                      : "bg-[#92C5EA]"
                  }`}
                >
                  <div className="flex items-center flex-grow cursor-pointer">
                    <span className="text-sm md:text-lg font-bold text-black">
                      {category.category}{" "}
                      <span className="font-medium">
                        {category.category === "Defensive"
                          ? `(${
                              investmentId == -1
                                ? defensive
                                : defensive.toFixed(2) + "%"
                            })`
                          : `(${
                              investmentId == -1
                                ? growth
                                : growth.toFixed(2) + "%"
                            })`}
                      </span>
                    </span>
                  </div>
                </div>

                {/* Subcategories */}
                <div
                  className={`ml-4 md:ml-6 border-l-2 ${
                    category.category === "Defensive"
                      ? "border-[#A9D4AB]"
                      : "border-[#92C5EA]"
                  }`}
                >
                  {category.product_allocations.map(
                    (subcategory, subcategoryIndex) => (
                      <div
                        key={subcategory}
                        className="relative mb-2 pt-1 text-left"
                      >
                        {/* Subcategory Header */}
                        <div className="flex items-center justify-start  rounded-md cursor-pointer">
                          {category.category === "Defensive" ? (
                            <img
                              src="/green-arrow.svg"
                              alt="Arrow"
                              className="w-5 h-5"
                            />
                          ) : (
                            <img
                              src="/arrow-hierarchy.svg"
                              alt="Arrow"
                              className="w-5 h-5"
                            />
                          )}
                          <div
                            className={`flex items-center p-4 w-full rounded-md cursor-pointer ${
                              category.category === "Defensive"
                                ? "bg-[#C0E2C1]"
                                : "bg-[#C6DFF1]"
                            }`}
                          >
                            <div
                              key={category.category}
                              className="flex items-center w-full"
                            >
                              {/* Subcategory Name */}
                              <div className="text-sm md:text-md w-1/3 font-bold text-black">
                                {`${subcategoryIndex + 1}. ${
                                  subcategory.product_name
                                }`}
                              </div>

                              {/* Allocation Input pushed to the rightmost side */}
                              <div className="flex-grow flex pr-10 justify-end">
                                <div className="relative">
                                  <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    max="100"
                                    disabled={true}
                                    value={Number(
                                      subcategory.current_allocation
                                    ).toFixed(2)}
                                    className="lg:w-30 w-30 text-sm bg-white px-3 py-3 rounded-xl text-black border shadow-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black"
                                  />
                                  <span className="absolute inset-y-0 right-3 flex items-center text-sm font-medium text-[#8C8C8C]">
                                    %
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Table of Items */}
                      </div>
                    )
                  )}
                </div>
                <div
                  className={`flex items-center p-4 mt-4 border rounded-md ${
                    category.category === "Defensive"
                      ? "border-[#A9D4AB]"
                      : "border-[#92C5EA]"
                  }`}
                >
                  <div
                    key={category.category}
                    className="flex items-center justify-between w-full space-x-4"
                  >
                    <div className="text-sm md:text-md font-bold text-black">
                      SUB-TOTAL {category.category}
                    </div>

                    <div className="text-sm md:text-md pr-12 font-bold text-black">
                      {Number(category.target_allocation).toFixed(2)} %
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div className="flex items-center p-4 border rounded-md border-black">
              <div className="flex items-center justify-between w-full space-x-4">
                <div className="text-sm md:text-md font-bold text-black">
                  TOTAL PORTFOLIO
                </div>

                <div className="text-sm md:text-md pr-12 font-bold text-black">
                  100.00%
                </div>
              </div>
            </div>
          </div>
        )}

        {filter == "details" && (
          <div className="bg-white mt-6 p-6 px-8 shadow-md rounded-md">
            {/* Header */}
            <h2 className="text-lg font-semibold font-semibold mb-4">
              Caprock Model Portfolio - {investmentProductName}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
              <div className="space-y-4">
                <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-3 gap-4 text-sm">
                  {allocationGraphData.map((item, index) => (
                    <div
                      key={item.product_name}
                      className="flex flex-col items-start break-words whitespace-normal"
                    >
                      {/* Product Name */}
                      <span className="font-medium text-sm text-[#A6A6A6] w-full break-words">
                        {item.product_name}
                      </span>

                      {/* Allocation Percentage */}
                      <span
                        className="text-md font-medium mt-1 break-words"
                        style={{ color: `#${item.color}` }}
                      >
                        {item.current_allocation.toFixed(2)}%
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Donut Chart */}
              <div className="flex justify-end">
                <div className="w-full md:w-2/3 lg:w-1/2">
                  <Doughnut data={donutData} options={donutOptions} />
                </div>
              </div>
            </div>
            <div className="py-6 px-4 bg-white">
              <div className="mb-4 flex flex-wrap justify-between items-center">
                <span>
                  <h3 className="text-lg font-semibold text-gray-800 w-full md:w-auto">
                    Historical Performance
                  </h3>

                  <p className="text-sm font-normal text-[#868686] w-full md:w-auto">
                    Caprock {investmentProductName}
                  </p>
                </span>{" "}
              </div>
              <div className=" flex w-full justify-between flex-wrap">
                <div className="pr-4 flex-wrap items-center">
                  <div className="flex">
                    {["10Y", "5Y", "1Y", "3M", "1M"].map((filter, index) => (
                      <button
                        key={filter}
                        className={`px-3 py-1 shadow-md ${
                          filter === "1M" ? "rounded-r-xl" : ""
                        }
            ${filter === "10Y" ? "rounded-l-xl" : ""}
             
               ${
                 selectedFilter === filter
                   ? "bg-black text-white"
                   : "bg-white text-black"
               }`}
                        onClick={() => setSelectedFilter(filter)}
                      >
                        {filter}
                      </button>
                    ))}
                  </div>
                </div>
                {/* Flex container for image and performance text */}
                <div className="flex flex-row mt-8 md:mt-0   md:flex-row items-start ml-auto space-x-0 space-y-0">
                  <div className="flex items-center">
                    <img src="/blue-taa.svg" alt="taa" className="mr-1" />
                    <span className="text-xs text-black">Total Price</span>
                  </div>
                  <div className="flex items-center pl-2">
                    <img
                      src="/red-saa.svg"
                      alt="income-orange"
                      className="mr-1"
                    />
                    <span className="text-xs text-black">Combined Indices</span>
                  </div>
                  <div className="flex items-center pl-2">
                    <img
                      src="/saa-icon.svg"
                      alt="income-orange"
                      className="mr-1"
                    />
                    <span className="text-xs text-black">SAA Update</span>
                  </div>
                </div>
              </div>
              {isLoadingGraph ? (
                <div className="shimmer-container-list mb-4 ">
                  {/* Creating 5 rows of shimmer effect */}
                  {[...Array(2)].map((_, rowIndex) => (
                    <div key={rowIndex} className="shimmer-row-list">
                      {/* Creating 7 cells in each row for shimmer */}
                      {[...Array(2)].map((_, colIndex) => (
                        <div key={colIndex} className="shimmer-cell-list h-20">
                          <div className="shimmer-loader"></div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{ width: "100%", height: "400px" }}>
                  <Line data={dataLine} options={optionsLine} />
                </div>
              )}
            </div>
          </div>
        )}
        {filter == "details" && (
          <div className="w-full p-6  mt-6 bg-white px-8  rounded-md shadow-sm">
            <div className="space-y-4 pt-4">
              {/* Historical Performance Note */}
              <div>
                <label
                  htmlFor="historical-performance"
                  className="block text-sm font-medium text-[#A6A6A6]"
                >
                  Past Performance
                </label>
                <div className="w-full mt-2 p-3 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                  {pastPerformance}
                </div>
              </div>

              {/* Disclaimer */}
              <div>
                <label
                  htmlFor="disclaimer"
                  className="block text-sm font-medium text-[#A6A6A6]"
                >
                  Disclaimer
                </label>
                <div className="w-full text-sm mt-2 p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                  {disclaimer}
                </div>
              </div>

              {/* Copyright */}
              <div>
                <label
                  htmlFor="copyright"
                  className="block text-sm font-medium text-[#A6A6A6]"
                >
                  Copyright
                </label>
                <div className="w-full mt-2 text-sm p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                  {copyright}{" "}
                </div>
              </div>
            </div>
          </div>
        )}
        {filter == "details" && details != null && (
          <div className="pdf-only">
            <div className="fixed -top-[9999px] -left-[9999px] w-[800px] h-[200px] pointer-events-none -z-10">
              <Line
                ref={historyChartRef}
                data={dataLine}
                options={optionsLine}
              />
            </div>
            <div className="w-60 h-60 pdf-only">
              <Doughnut
                ref={chartRef}
                data={dataset}
                options={optionshide}
                // plugins={[plugin]} // Ensures percentages are displayed in the donut center
              />
            </div>
          </div>
        )}
        {filter == "view" && (
          <div className="w-full  p-4 bg-white rounded-lg shadow-lg lg:min-w-[78vw] lg:max-w-[80vw]">
            <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
              <h1 className="text-lg font-medium mb-2">
                Caprock Model Portfolio - {investmentProductName}
              </h1>
            </div>
            <div className="mt-2 border rounded-md">
              <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                <h1 className="text-md font-medium mb-2 text-black text-center">
                  Basic Details
                </h1>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div className="flex flex-col px-4 pt-4">
                  <label
                    htmlFor="refId"
                    className="mb-1 text-sm text-[#A6A6A6]"
                  >
                    Ref ID
                  </label>
                  <span>{refId}</span>
                  <div className="mt-4">
                    <label
                      htmlFor="investmentType"
                      className="mb-1 text-sm text-[#A6A6A6]"
                    >
                      strategy Type
                    </label>
                    <div>{strategyType}</div>
                  </div>
                  <div className="mt-4">
                    <label
                      htmlFor="investmentType"
                      className="mb-1  text-sm text-[#A6A6A6]"
                    >
                      Risk Profile
                    </label>
                    <div>{riskProfile}</div>
                  </div>
                </div>
                {/* center column */}
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 text-sm"
                  >
                    <span className="text-[#A6A6A6]">Investment Manager</span>
                  </label>
                  <div>{investmentManagerNamefromAPI}</div>
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 mt-4 text-sm"
                  >
                    <span className="text-[#A6A6A6]">Sub Advisor</span>
                  </label>
                  <div>{subadvisorIdfromAPI}</div>
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 mt-4 text-sm"
                  >
                    <span className="text-[#A6A6A6]">Advisor</span>
                  </label>
                  <div>{advisorIdfromAPI}</div>
                </div>
                {/* Left column */}
                <div className="flex lg:pt-4 pt-0 flex-col px-4">
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 text-sm"
                  >
                    <span className="text-[#A6A6A6]">Asset Manager</span>
                  </label>
                  <div>{assetManagerNamefromAPI}</div>
                  <label
                    htmlFor="investmentType"
                    className="mb-1 mt-4 text-sm text-[#A6A6A6]"
                  >
                    Investment Type
                  </label>
                  <div>{investmentType}</div>
                </div>
              </div>

              {/* Fund Objective & Process Section */}
              <div className="mt-6 mb-4 px-4">
                <label
                  htmlFor="fundObjective"
                  className="block mb-1 text-sm text-[#A6A6A6]"
                >
                  Fund Objective & Process
                </label>
                <div
                  dangerouslySetInnerHTML={{ __html: fundObjectives }}
                  className="text-sm"
                ></div>
              </div>
            </div>
          </div>
        )}
        {filter == "view" && (
          <div>
            <div className="w-full p-4 mt-6 bg-white rounded-lg shadow-lg">
              <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
                <h1 className="text-lg font-medium mb-2">
                  Caprock Model Portfolio - {investmentProductName}
                </h1>
              </div>
              <div className="mt-2 border  rounded-md">
                <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                  <h1 className="text-md font-medium mb-2 text-black text-center">
                    Investment Details
                  </h1>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 mb-4 md:grid-cols-3 gap-6">
                  <div className="flex flex-col px-4 pt-4">
                    <label
                      htmlFor="refId"
                      className="mb-1 text-sm text-[#A6A6A6]"
                    >
                      Code
                    </label>
                    <span>{refId}</span>
                    <div className="mt-4">
                      <label
                        htmlFor="investmentType"
                        className="mb-1 text-sm text-[#A6A6A6]"
                      >
                        Investment Product Name
                      </label>
                      <div>{investmentProductName}</div>
                    </div>
                    <div className="mt-4">
                      <label
                        htmlFor="investmentType"
                        className="mb-1  text-sm text-[#A6A6A6]"
                      >
                        Risk Rating
                      </label>
                      <div>{riskRating}</div>
                    </div>
                    <div className="mt-4">
                      <label
                        htmlFor="investmentType"
                        className="mb-1  text-sm text-[#A6A6A6]"
                      >
                        Advisor Fees %
                      </label>
                      <div>{advisorFees}</div>
                    </div>
                    <div className="mt-4">
                      <label
                        htmlFor="investmentType"
                        className="mb-1  text-sm text-[#A6A6A6]"
                      >
                        SMA Fees % | Including GST
                      </label>
                      <div>{smaFees}</div>
                    </div>
                  </div>
                  {/* center column */}
                  <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                    <div className="grid grid-cols-2 gap-4">
                      {/* Growth (%) */}
                      <div>
                        <label className="block text-sm text-[#A6A6A6]">
                          Growth (%)
                        </label>
                        <div className="relative">{growth}</div>
                      </div>

                      {/* Defensive (%) */}
                      <div>
                        <label className="block text-sm text-[#A6A6A6]">
                          Defensive (%)
                        </label>
                        <div className="relative">{defensive}</div>
                      </div>
                    </div>

                    {/* Investments */}
                    {investmentId && investmentId != -1 && (
                      <div>
                        <label className="block mb-1 mt-4 text-sm text-[#A6A6A6]">
                          Investments
                        </label>
                        <div className="mt-1   flex flex-wrap gap-2">
                          {investments.map((investment, index) => (
                            <div
                              key={index}
                              className="flex items-center bg-[#FCFCFC] text-gray-700 text-sm px-3 py-1 rounded-lg border shadow-sm"
                            >
                              <span>{investment}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  {/* Left column */}
                  <div className="flex lg:pt-4 pt-0 flex-col px-4">
                    <label
                      htmlFor="investmentManagerFees"
                      className=" mb-1 text-sm"
                    >
                      <span className="text-[#A6A6A6]">
                        Investment Manager Fees % | Weighted Average
                      </span>
                    </label>
                    <div>{managerFees}</div>
                    <label
                      htmlFor="investmentManagerFees"
                      className=" mb-1 mt-4 text-sm"
                    >
                      <span className="text-[#A6A6A6]">Sub Advisor Fees %</span>
                    </label>
                    <div>{subadvisorFees}</div>
                    <label
                      htmlFor="investmentManagerFees"
                      className=" mb-1 mt-4 text-sm"
                    >
                      <span className="text-[#A6A6A6]">
                        Strategy Inception Date
                      </span>
                    </label>
                    <div>{strategyDate}</div>
                    <label
                      htmlFor="investmentManagerFees"
                      className=" mb-1 mt-4 text-sm"
                    >
                      <span className="text-[#A6A6A6]">
                        Minimum Investment Amount
                      </span>
                    </label>
                    <div>
                      $
                      {(minimumInvestedAmount == null
                        ? 0
                        : minimumInvestedAmount
                      )
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </div>
                    <div className="mt-4">
                      <label
                        htmlFor="investmentType"
                        className="mb-1  text-sm text-[#A6A6A6]"
                      >
                        Asset Manager Fees %
                      </label>
                      <div>{assetManagerFees}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {investmentId && investmentId != -1 && (
              <DocumentsSection IsUpdate={true} investment_id={investmentId} />
            )}
          </div>
        )}
        {filter == "manage-funds" && (
          <div className="w-full lg:min-w-[78vw] lg:max-w-[80vw]">
            {isLoading || !manageFundData ? (
              <div className="shimmer-container-list mb-4 ">
                {/* Creating 5 rows of shimmer effect */}
                {[...Array(2)].map((_, rowIndex) => (
                  <div key={rowIndex} className="shimmer-row-list">
                    {/* Creating 7 cells in each row for shimmer */}
                    {[...Array(2)].map((_, colIndex) => (
                      <div key={colIndex} className="shimmer-cell-list h-20">
                        <div className="shimmer-loader"></div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ) : (
              <div>
                <div className="w-full lg:min-w-[78vw] lg:max-w-[80vw]  p-4 bg-white rounded-lg shadow-lg">
                  <div className="flex flex-col md:flex-row md:justify-between md:items-center border-b pt-2 pb-3 gap-y-2">
                    {/* Left-aligned Dropdown */}
                    <div className="w-full md:w-[40rem]">
                      <Dropdown
                        label=""
                        options={investmentportfolioData}
                        preselectedValue={preSelectedInvestmentFilter}
                        onSelect={handleInvestmentFilterChange}
                      />
                    </div>

                    {/* Right-aligned Info Block */}
                    <div className="flex flex-wrap items-center gap-x-2 justify-start md:justify-end w-full md:w-auto">
                      <div className="flex flex-col items-start md:items-end">
                        <span className="text-sm font-semibold text-[#464646] leading-tight">
                          Current portfolio value
                        </span>
                      </div>
                      <span className="text-md font-semibold">|</span>
                      <span className="text-sm font-semibold rounded-md text-white py-1 px-3 bg-[#34C046]">
                        $
                        {manageFundData.current_portfolio_value
                          ? manageFundData.current_portfolio_value
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          : "0.00"}
                      </span>
                      <span className="text-md font-semibold">|</span>
                      <div className="flex flex-col items-start md:items-end">
                        <span className="text-sm font-semibold text-[#464646] leading-tight">
                          Cash Account Balance
                        </span>
                      </div>
                      <span className="text-sm font-semibold">|</span>
                      <span className="text-sm font-semibold rounded-md text-white py-1 px-3 bg-[#3047EC]">
                        $
                        {manageFundData.cash_account_balance
                          ? manageFundData.cash_account_balance
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          : "0.00"}
                      </span>
                    </div>
                  </div>
                  {investmentId && investmentId != -1 && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 md:gap-4 font-semibold mt-4  text-sm">
                      <div className="bg-[#62D76E] pb-4 bg-opacity-20 px-4 py-2 rounded-lg flex flex-col leading-none space-y-[10px]">
                        <span className="text-sm font-semibold">
                          Add Amount from Cash account to invest in this
                          portfolio
                        </span>
                        <span
                          onClick={(e) => {
                            e.preventDefault();
                            handleUserClick("Add Amount", 1);
                          }}
                          className="bg-[#34C046] cursor-pointer px-2 py-2 mt-2 w-40 text-center text-white rounded-full text-sm font-medium"
                        >
                          Add Amount
                        </span>
                      </div>
                      <div className="bg-[#005A9C] bg-opacity-20 px-4 py-2 rounded-lg flex flex-col leading-none space-y-[10px]">
                        <span className="text-sm font-semibold">
                          Request a withdrawal of Amount from this portfolio to
                          Cash account
                        </span>
                        <span
                          onClick={(e) => {
                            e.preventDefault();
                            handleUserClick("Withdraw Amount", 2);
                          }}
                          className="bg-[#005A9C] cursor-pointer px-2 py-2 mt-2 w-40 text-center text-white rounded-full text-sm font-medium"
                        >
                          Withdraw Amount
                        </span>
                      </div>
                      <div className="bg-[#FF5050] bg-opacity-20 px-4 py-2 rounded-lg flex flex-col leading-none space-y-[10px]">
                        <span className="text-sm font-semibold">
                          Liquidate all assets in your portfolio and transfer
                          the funds to cash account
                        </span>
                        <span
                          onClick={(e) => {
                            e.preventDefault();
                            handleUserClick("Sell Portfolio", 3);
                          }}
                          className="bg-[#FF5050] cursor-pointer px-2 py-2 mt-2 w-40 text-center text-white rounded-full text-sm font-medium"
                        >
                          Sell Porfolio
                        </span>
                      </div>
                    </div>
                  )}
                  {investmentId && investmentId == -1 && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-2 md:gap-4 font-semibold mt-4  text-sm">
                      <div className="bg-[#005A9C] bg-opacity-20 px-4 py-2 rounded-lg flex flex-col leading-none space-y-[10px]">
                        <span className="text-sm font-semibold">
                          Request a withdrawal from this portfolio to Cash
                          account
                        </span>
                        <span
                          onClick={(e) => {
                            e.preventDefault();
                            handleUserClick("Withdraw", 2);
                          }}
                          className="bg-[#005A9C] cursor-pointer px-2 py-2 mt-2 w-40 text-center text-white rounded-full text-sm font-medium"
                        >
                          Withdraw
                        </span>
                      </div>
                      <div className="bg-[#FF5050] bg-opacity-20 px-4 py-2 rounded-lg flex flex-col leading-none space-y-[10px]">
                        <span className="text-sm font-semibold">
                          Liquidate all assets in your portfolio and transfer
                          the funds to cash account
                        </span>
                        <span
                          onClick={(e) => {
                            e.preventDefault();
                            handleUserClick("Sell Portfolio", 3);
                          }}
                          className="bg-[#FF5050] cursor-pointer px-2 py-2 mt-2 w-40 text-center text-white rounded-full text-sm font-medium"
                        >
                          Sell Porfolio
                        </span>
                      </div>
                    </div>
                  )}
                  {isAddFundPopupOpen && (
                    <CustomerPopup
                      investmentID={investmentId}
                      customerId={customerId}
                      onClose={() => setIsAddFundPopupOpen(false)}
                      functionName={currentFunctionName}
                      functionId={currentFunctionId}
                      updateTransactionHistory={fetchTrancationHistory}
                    />
                  )}
                </div>
                {investmentId && investmentId == -1 && (
                  <>
                    {isMatchFound && (
                      <div className="font-medium bg-white mt-6 p-4 rounded-xl shadow-sm border border-gray-200 text-sm text-gray-900">
                        {/* Header Section */}
                        <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 gap-4">
                          <h3 className="text-base font-semibold text-black flex items-center gap-2">
                            {/* Replace with any SVG above */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-6 h-6 text-black"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M3 7l9-4 9 4-9 4-9-4zm0 6l9 4 9-4m-9 4v5"
                              />
                            </svg>
                            Recommended Strategies
                          </h3>

                          <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                            {/* Show Records */}
                            <div className="flex items-center gap-2">
                              <span className="text-gray-600">Show</span>
                              <Dropdown
                                label=""
                                options={filterOptions}
                                preselectedValue={preSelectedFilter}
                                onSelect={handleshowRecord}
                              />
                            </div>

                            {/* Search */}
                            <div className="relative w-full sm:w-auto">
                              <input
                                type="text"
                                className="pl-9 pr-3 py-1.5 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-black focus:outline-none w-full sm:w-60 text-sm"
                                placeholder="Search strategy"
                                value={searchQuery}
                                onChange={(e) => {
                                  setCurrentPage(1);
                                  setSearchQuery(e.target.value);
                                }}
                              />
                              <img
                                src="/search-normal.svg"
                                alt="Search"
                                className="absolute left-3 top-2 w-4 h-4 text-gray-400"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Table */}
                        <div className="overflow-x-auto">
                          <table className="min-w-full border-separate border-spacing-y-1 text-sm">
                            <thead className="bg-gray-100 text-gray-700">
                              <tr>
                                {portfolioAccountheaders.map((header) => (
                                  <th
                                    key={header.label}
                                    onClick={() => handleSort(header.key)}
                                    className="px-4 py-2 text-left font-medium cursor-pointer whitespace-nowrap"
                                  >
                                    <div className="flex items-center space-x-1">
                                      <span>{header.label}</span>
                                    </div>
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {isLoadingPortfolio ? (
                                [...Array(5)].map((_, i) => (
                                  <tr
                                    key={i}
                                    className="rounded border border-gray-100 bg-white"
                                  >
                                    {[...Array(4)].map((_, j) => (
                                      <td key={j} className="px-4 py-3">
                                        <div className="h-3 bg-gray-200 rounded animate-pulse"></div>
                                      </td>
                                    ))}
                                  </tr>
                                ))
                              ) : portfolioAccounttableData.length > 0 ? (
                                portfolioAccounttableData.map((row, index) => (
                                  <tr
                                    key={index}
                                    className={`transition-colors border border-gray-100 ${
                                      index % 2 === 0
                                        ? "bg-white"
                                        : "bg-gray-50"
                                    } hover:bg-indigo-50`}
                                  >
                                    <td className="px-4 py-3 whitespace-nowrap">
                                      {row.ref_code}
                                    </td>
                                    <td
                                      onClick={() => {
                                        let redirectState = {
                                          path: "/strategy-details",
                                          state: {
                                            from: location.pathname,
                                            strategyid: row.strategy_id,
                                            strategyName: row.strategy_name,
                                            userid: customerId,
                                            historyStack: [
                                              ...(location.state
                                                ?.historyStack || []),
                                              location.pathname,
                                            ],
                                          },
                                        };
                                        sessionStorage.setItem(
                                          "redirectAfterLogin",
                                          JSON.stringify(redirectState)
                                        );
                                        navigate("/strategy-details", {
                                          state: {
                                            from: location.pathname,
                                            strategyid: row.strategy_id,
                                            strategyName: row.strategy_name,
                                            userid: customerId,
                                            historyStack: [
                                              ...(location.state
                                                ?.historyStack || []),
                                              location.pathname,
                                            ],
                                          },
                                        });
                                      }}
                                      className="px-4 py-3 text-[#005A9C] hover:underline cursor-pointer whitespace-normal font-medium"
                                    >
                                      Caprock Model portfolio -{" "}
                                      {row.strategy_name}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap font-semibold text-emerald-600">
                                      {row.overall_matching_percentage
                                        ? row.overall_matching_percentage.toFixed(
                                            2
                                          ) + "%"
                                        : "0.00"}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap">
                                      $
                                      {row.overall_matching_percentage
                                        ? row.minimum_investment
                                            .toFixed(2)
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ","
                                            )
                                        : "0.00"}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={4}
                                    className="px-4 py-4 text-center text-gray-500"
                                  >
                                    No results found.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>

                        {/* Pagination */}
                        {!isLoading && (
                          <div className="flex flex-col sm:flex-row justify-between items-center mt-4 text-gray-700 text-xs gap-3">
                            <div>
                              Showing{" "}
                              {showRecordsStrategies *
                                (currentPageStrategies - 1) +
                                1}{" "}
                              to{" "}
                              {currentPageStrategies === totalPageStrategies ||
                              totalPageStrategies === 0
                                ? totalCountStrategies
                                : Math.min(
                                    showRecordsStrategies *
                                      currentPageStrategies,
                                    totalCountStrategies
                                  )}{" "}
                              of {totalCountStrategies} entries
                            </div>
                            <div className="flex gap-1">
                              <button
                                disabled={currentPageStrategies === 1}
                                onClick={() =>
                                  setCurrentPageStrategies((prev) => prev - 1)
                                }
                                className="px-2.5 py-1 rounded bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
                              >
                                Prev
                              </button>
                              {Array.from({
                                length: Math.min(totalPageStrategies, 5),
                              }).map((_, i) => {
                                const startPage = Math.max(
                                  1,
                                  Math.min(
                                    totalPageStrategies - 4,
                                    currentPageStrategies - 2
                                  )
                                );
                                const page = startPage + i;
                                return (
                                  <button
                                    key={page}
                                    onClick={() =>
                                      setCurrentPageStrategies(page)
                                    }
                                    className={`px-2.5 py-1 rounded ${
                                      currentPageStrategies === page
                                        ? "bg-black text-white font-semibold"
                                        : "bg-white border border-gray-300 hover:bg-gray-100"
                                    }`}
                                  >
                                    {page}
                                  </button>
                                );
                              })}
                              <button
                                disabled={
                                  currentPageStrategies ===
                                    totalPageStrategies ||
                                  totalPageStrategies === 0
                                }
                                onClick={() =>
                                  setCurrentPageStrategies((prev) => prev + 1)
                                }
                                className="px-2.5 py-1 rounded bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
                              >
                                Next
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    {!isMatchFound && nearestStrategies.length > 0 && (
                      <NoMatchSection
                        nearestStrategies={nearestStrategies}
                        fromGuest={false}
                      />
                    )}
                  </>
                )}
                <div className="lg:flex mt-4 w-full">
                  <div className="w-full  p-4 bg-white rounded-lg shadow-lg">
                    <h2 className="text-lg font-bold">Portfolio Details</h2>
                    {isLoadingDetails ? (
                      <div className="shimmer-container-list mb-4 ">
                        {/* Creating 5 rows of shimmer effect */}
                        {[...Array(1)].map((_, rowIndex) => (
                          <div key={rowIndex} className="shimmer-row-list">
                            {/* Creating 7 cells in each row for shimmer */}
                            {[...Array(2)].map((_, colIndex) => (
                              <div
                                key={colIndex}
                                className="shimmer-cell-list h-20"
                              >
                                <div className="shimmer-loader "></div>
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 md:gap-4 font-semibold mt-4  text-sm">
                          <div className="bg-[#3047EC] bg-opacity-20 px-4 py-2 rounded-lg flex flex-col leading-none space-y-[2px]">
                            <span className="text-sm font-semibold">
                              Total Invested
                            </span>
                            <span className="text-[#3047EC] text-sm font-semibold">
                              $
                              {totalInvested
                                ? totalInvested
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : "0.00"}
                            </span>
                          </div>
                          <div className="bg-[#62D76E] bg-opacity-20 px-4 py-2 rounded-lg flex flex-col leading-none space-y-[2px]">
                            <div>
                              <Dropdown
                                label="Change in Balance"
                                options={balanceChanges}
                                preselectedValue={preSelectedBalanceChanges}
                                onSelect={handleBalanceChangesChange}
                                font="small"
                                colorLabel="text-black"
                              />
                            </div>
                            {balanceChangeFilterValue == "1M" && (
                              <>
                                {totalInvestedDetails &&
                                  totalInvestedDetails.monthly < 0 && (
                                    <span className="text-[#FF5050] text-sm font-semibold">
                                      -${" "}
                                      {totalInvestedDetails?.monthly
                                        ? Math.abs(totalInvestedDetails.monthly)
                                            .toFixed(2)
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ","
                                            )
                                        : "0.00"}{" "}
                                    </span>
                                  )}
                                {totalInvestedDetails &&
                                  totalInvestedDetails.monthly >= 0 && (
                                    <span className="text-[#34C046] text-sm font-semibold">
                                      +${" "}
                                      {totalInvestedDetails?.monthly
                                        ? totalInvestedDetails.monthly
                                            .toFixed(2)
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ","
                                            )
                                        : "0.00"}{" "}
                                    </span>
                                  )}
                              </>
                            )}
                            {balanceChangeFilterValue == "All" && (
                              <>
                                {totalInvestedDetails &&
                                  totalInvestedDetails.all_time < 0 && (
                                    <span className="text-[#FF5050] text-sm font-semibold">
                                      -${" "}
                                      {totalInvestedDetails?.all_time
                                        ? Math.abs(
                                            totalInvestedDetails.all_time
                                          )
                                            .toFixed(2)
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ","
                                            )
                                        : "0.00"}{" "}
                                    </span>
                                  )}
                                {totalInvestedDetails &&
                                  totalInvestedDetails.all_time >= 0 && (
                                    <span className="text-[#34C046] text-sm font-semibold">
                                      +${" "}
                                      {totalInvestedDetails?.all_time
                                        ? totalInvestedDetails.all_time
                                            .toFixed(2)
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ","
                                            )
                                        : "0.00"}{" "}
                                    </span>
                                  )}
                              </>
                            )}
                            {balanceChangeFilterValue == "1Y" && (
                              <>
                                {totalInvestedDetails &&
                                  totalInvestedDetails.yearly < 0 && (
                                    <span className="text-[#FF5050] text-sm font-semibold">
                                      -${" "}
                                      {totalInvestedDetails?.yearly
                                        ? Math.abs(totalInvestedDetails.yearly)
                                            .toFixed(2)
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ","
                                            )
                                        : "0.00"}{" "}
                                    </span>
                                  )}
                                {totalInvestedDetails &&
                                  totalInvestedDetails.yearly >= 0 && (
                                    <span className="text-[#34C046] text-sm font-semibold">
                                      +${" "}
                                      {totalInvestedDetails?.yearly
                                        ? totalInvestedDetails.yearly
                                            .toFixed(2)
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ","
                                            )
                                        : "0.00"}{" "}
                                    </span>
                                  )}
                              </>
                            )}
                            {balanceChangeFilterValue == "1W" && (
                              <>
                                {totalInvestedDetails &&
                                  totalInvestedDetails.weekly < 0 && (
                                    <span className="text-[#FF5050] text-sm font-semibold">
                                      -${" "}
                                      {totalInvestedDetails?.weekly
                                        ? Math.abs(totalInvestedDetails.weekly)
                                            .toFixed(2)
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ","
                                            )
                                        : "0.00"}{" "}
                                    </span>
                                  )}
                                {totalInvestedDetails &&
                                  totalInvestedDetails.weekly >= 0 && (
                                    <span className="text-[#34C046] text-sm font-semibold">
                                      +${" "}
                                      {totalInvestedDetails?.weekly
                                        ? totalInvestedDetails.weekly
                                            .toFixed(2)
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ","
                                            )
                                        : "0.00"}{" "}
                                    </span>
                                  )}
                              </>
                            )}
                            {!totalInvestedDetails && (
                              <span className="text-[#34C046] text-sm font-semibold">
                                $0.00
                              </span>
                            )}
                          </div>
                          <ReinvestProgressCard
                            customerId={customerId}
                            investmentID={investmentId}
                            totalAmount={totalDividend}
                            threshold={totalThreshold} // You can also get this from state or API
                          />
                          {/* <div className="bg-[#62D76E] bg-opacity-20 px-4 py-2 rounded-lg flex flex-col leading-none space-y-[2px]">
                        <span className="text-[10px] font-semibold">
                          All-Time Change
                        </span>

                        {totalInvestedDetails &&
                          totalInvestedDetails.all_time_change < 0 && (
                            <span className="text-[#FF5050] text-sm font-semibold">
                              -${" "}
                              {totalInvestedDetails?.all_time_change
                                ? Math.abs(totalInvestedDetails.all_time_change)
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : "0.00"}{" "}
                              (
                              {totalInvestedDetails?.all_time_change_percentage
                                ? Math.abs(
                                    totalInvestedDetails.all_time_change_percentage
                                  ).toFixed(2)
                                : "0.00"}
                              %)
                            </span>
                          )}
                        {totalInvestedDetails &&
                          totalInvestedDetails.all_time_change >= 0 && (
                            <span className="text-[#34C046] text-sm font-semibold">
                              +${" "}
                              {totalInvestedDetails?.all_time_change
                                ? totalInvestedDetails.all_time_change
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : "0.00"}{" "}
                              (
                              {totalInvestedDetails?.all_time_change_percentage
                                ? totalInvestedDetails.all_time_change_percentage.toFixed(
                                    2
                                  )
                                : "0.00"}
                              %)
                            </span>
                          )}
                        {!totalInvestedDetails && (
                          <span className="text-[#34C046] text-sm font-semibold">
                            $0.00
                          </span>
                        )}
                      </div> */}
                        </div>
                        {/* <ReinvestProgressCard
                          totalAmount={1500}
                          threshold={10} // You can also get this from state or API
                        /> */}
                      </>
                    )}
                    <div className="mb-4 mt-4 flex w-full justify-between flex-wrap">
                      <div className="pr-4 flex-wrap items-center">
                        <div className="flex">
                          {["All", "1Y", "1M", "1W"].map((filter, index) => (
                            <button
                              key={filter}
                              className={`px-3 py-1 text-sm shadow-md ${
                                filter === "1W" ? "rounded-r-xl" : ""
                              }
      ${filter === "All" ? "rounded-l-xl" : ""}
      ${
        selectedFilterHour === filter
          ? "bg-black font-bold text-white"
          : "bg-white text-black"
      }
      sm:px-2 sm:py-1`} // Added for responsiveness
                              onClick={() => {
                                setSelectedFilterHour(filter);
                                setBalanceChangeFilterValue(filter);
                                let preValue = balanceChanges.filter(
                                  (item) => item.value == filter
                                );
                                setpreSelectedBalanceChanges(preValue[0]);
                              }}
                            >
                              {filter}
                            </button>
                          ))}
                        </div>
                      </div>
                      {/* Custom hours */}
                      {/* <div className="flex items-center text-sm mt-1 md:mt-0  space-x-1 ml-1 border px-1 py-1 rounded-md bg-white shadow-md">
                        <button
                          onClick={() => handleCustomTimeChange(-1)}
                          className="text-black"
                        >
                          <Minus size={14} />
                        </button>
                        <span className="text-xs font-medium">
                          {customTime}H
                        </span>
                        <button
                          onClick={() => handleCustomTimeChange(1)}
                          className="text-black"
                        >
                          <Plus size={14} />
                        </button>
                      </div> */}

                      {/* Flex container for image and performance text */}
                      <div className="flex flex-col mt-2 md:mt-0   md:flex-col items-start ml-auto space-x-0 space-y-0">
                        <div className="flex items-center">
                          <img
                            src="/growth-blue.svg"
                            alt="performance"
                            className="mr-2"
                          />
                          <span className="text-xs text-[#8C8C8C]">
                            Performance
                          </span>
                        </div>
                        <div className="flex items-center">
                          <img
                            src="/income-orange.svg"
                            alt="income-orange"
                            className="mr-2"
                          />
                          <span className="text-xs text-[#8C8C8C]">
                            Net Invested Amount
                          </span>
                        </div>
                      </div>
                    </div>
                    {isLoadingGraph ? (
                      <div className="shimmer-container-list mb-4 ">
                        {/* Creating 5 rows of shimmer effect */}
                        {[...Array(1)].map((_, rowIndex) => (
                          <div key={rowIndex} className="shimmer-row-list">
                            {/* Creating 7 cells in each row for shimmer */}
                            {[...Array(2)].map((_, colIndex) => (
                              <div
                                key={colIndex}
                                className="shimmer-cell-list h-20"
                              >
                                <div className="shimmer-loader "></div>
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="w-full" style={{ height: "400px" }}>
                        <MultiLineChart
                          graphData={performanceGraph}
                          selectedFilter={selectedFilterHour}
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className="w-full mt-6 mb-2 p-4 bg-white rounded-lg shadow-lg">
                  <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
                    <div className="flex items-center">
                      <span className="font-medium lg:text-xl text-sm">
                        Transaction History
                      </span>
                    </div>
                  </div>
                  <div className="flex justify-between flex-wrap mb-4 gap-4 mb-4">
                    <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                      <div className="flex items-center space-x-2">
                        <span className="lg:text-md  text-sm text-[#8C8C8C]">
                          Show Records
                        </span>
                        <Dropdown
                          label=""
                          options={filterOptions}
                          preselectedValue={preSelectedFilter}
                          onSelect={handleFilterChange}
                        />
                      </div>
                      <div className="flex items-center">
                        <div className="relative">
                          <input
                            type="text"
                            className="p-2 pl-8 border rounded-xl w-full"
                            placeholder="Search Name"
                            value={searchQuery}
                            onChange={(e) => {
                              setCurrentPage(1);
                              setSearchQuery(e.target.value);
                            }}
                          />
                          <span className="absolute left-2 top-3 text-gray-500">
                            {" "}
                            <img
                              src="/search-normal.svg"
                              alt="Company Logo"
                              className="mr-2"
                            />
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="flex justify-end flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-2">
                      <div
                        ref={DateCalendarRef}
                        className="flex items-center space-x-4"
                      >
                        <div className="relative w-full">
                          {/* Dropdown Trigger */}
                          <div
                            className="flex items-center justify-between p-2 w-60 md:w-60 border rounded-xl bg-white cursor-pointer"
                            onClick={toggleDropdown}
                          >
                            <span>{selectedRange}</span>
                            <img
                              src="/download-small-arrow.svg"
                              alt="Dropdown"
                              className="w-2 h-2"
                            />
                          </div>

                          {/* Dropdown */}
                          {isDropdownOpen && (
                            <div className="absolute top-12  md:left-1/4 left-0 transform md:-translate-x-1/2  mt-2 bg-white border rounded-lg shadow-lg z-10 w-[90vw] md:w-[900px] max-h-[400px] overflow-auto">
                              <div className="flex  flex-col md:flex-row h-full">
                                {/* Left: Quick Filters */}
                                <div className="w-full md:w-1/3 border-r p-3 h-full">
                                  {quickFilters.map((filter) => (
                                    <div
                                      key={filter.value}
                                      className={`p-2 cursor-pointer rounded ${
                                        quickFilter === filter.value
                                          ? "bg-black text-white"
                                          : "hover:bg-gray-200 text-black"
                                      } transition-all duration-200 ease-in-out`}
                                      onClick={() =>
                                        handleQuickFilter(filter.value)
                                      }
                                    >
                                      {filter.label}
                                    </div>
                                  ))}
                                </div>

                                {/* Right: Calendar */}
                                <div className="w-full md:w-2/3 overflow-auto p-3 h-full">
                                  <Flatpickr
                                    key={selectedDates}
                                    options={{
                                      mode: "range",
                                      inline: true,
                                      dateFormat: "Y-m-d",
                                      showMonths: 2,
                                      defaultDate:
                                        selectedDates.length > 0
                                          ? selectedDates
                                          : [],
                                      shorthandCurrentMonth: true,
                                      locale: {
                                        firstDayOfWeek: 1, // Sets Monday as the first day of the week
                                      },
                                      onChange: (dates) => {
                                        if (
                                          quickFilter === "custom" &&
                                          dates.length === 2
                                        ) {
                                          setSelectedDates(dates);
                                        }
                                      },
                                    }}
                                    className="w-full"
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        ref={DownloadRef}
                        className="flex items-center space-x-4"
                      >
                        <div className="relative inline-block ">
                          <div
                            className="flex justify-between items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                            onClick={() => setIsOpen(!isOpen)}
                          >
                            <img
                              src="/document-download.svg"
                              alt="document-download"
                              className="mr-2"
                            />
                            <span>{selected}</span>
                            <span className="text-gray-500">
                              {" "}
                              <img
                                src="/download-small-arrow.svg"
                                alt="Dropdown"
                                className="w-2 h-2"
                              />
                            </span>
                          </div>
                          {isOpen && (
                            <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                              {options.map((option) => (
                                <li
                                  key={option.value}
                                  className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setLoading(true);
                                    downloadPDFTable(e, option);
                                  }}
                                >
                                  {option.label}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="overflow-x-auto mt-4">
                    <table className="table-auto border-collapse font-medium w-full text-xs">
                      <thead>
                        <tr className="bg-[#ECFFEE] text-[#005A9C]">
                          <th className="border  text-left px-4 py-2">Date</th>
                          <th className="border text-left px-4 py-2">
                            Transaction
                          </th>
                          <th className="border text-left px-4 py-2">Amount</th>
                          <th className="border text-left px-4 py-2">
                            Transaction Status
                          </th>
                          <th className="border text-left px-4 py-2">
                            Stock Status
                          </th>
                        </tr>
                      </thead>
                      {isLoadingHistory ? (
                        <tbody className="shimmer-container-list ">
                          {/* Creating 5 rows of shimmer effect */}
                          {[...Array(5)].map((_, rowIndex) => (
                            <tr key={rowIndex} className="shimmer-row-list">
                              {/* Creating 7 cells in each row for shimmer */}
                              {[...Array(5)].map((_, colIndex) => (
                                <td
                                  key={colIndex}
                                  className="shimmer-cell-list"
                                >
                                  <div className="shimmer-loader"></div>
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody>
                          {transactionHistoryData.length > 0 ? (
                            transactionHistoryData.map((row, index) => (
                              <tr key={row.id} className="text-black">
                                <td className="border px-4 py-2">
                                  {formatDateList(row.created_at)}
                                </td>
                                <td className="border px-4 py-2">{row.type}</td>
                                <td className="border px-4 py-2">
                                  $
                                  {row.amount
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </td>
                                <td className="border px-4 py-2">
                                  {row.status}
                                </td>
                                <td className="border px-4 py-2">
                                  {row.stock_status}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td className="text-center py-4" colSpan="7">
                                No results found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </table>
                  </div>

                  {transactionHistoryData != null && (
                    <div className="flex flex-wrap justify-between items-center mt-6 mb-4 space-y-4 sm:space-y-0">
                      <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                        Showing {showRecords * (currentPage - 1) + 1} to{" "}
                        {currentPage === totalPages || totalPages == 0
                          ? totalCount
                          : Math.max(
                              showRecords * currentPage,
                              transactionHistoryData.length
                            )}{" "}
                        of {totalCount} entries
                      </div>

                      <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                        <button
                          disabled={currentPage === 1}
                          onClick={() => setCurrentPage((prev) => prev - 1)}
                          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Prev
                        </button>
                        {Array.from({ length: Math.min(totalPages, 5) }).map(
                          (_, index) => {
                            const startPage = Math.max(
                              1,
                              Math.min(totalPages - 4, currentPage - 2)
                            );
                            const page = startPage + index;

                            return (
                              <button
                                key={page}
                                onClick={() => setCurrentPage(page)}
                                className={`px-3 py-1 rounded ${
                                  currentPage === page
                                    ? "bg-black text-white"
                                    : "bg-white border border-gray-300 text-black"
                                }`}
                              >
                                {page}
                              </button>
                            );
                          }
                        )}
                        <button
                          disabled={currentPage === totalPages}
                          onClick={() => setCurrentPage((prev) => prev + 1)}
                          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
        <div className="flex items-center mt-6 mb-4 p-4 bg-[#005A9C]">
          {/* Left Section: Back Button */}
          <div className="flex items-center justify-start w-full space-x-4">
            <div
              onClick={() => navigate("/my-investments")}
              className="flex items-center space-x-2 text-sm md:text-md font-medium py-1 px-8 text-white cursor-pointer"
            >
              {/* Image on the left */}
              <img
                src="/white-arrow-back.svg" // Path to your image
                alt="Back Icon"
                className="w-4 h-4"
              />
              <span>Back</span>
            </div>
          </div>

          {/* Right Section: Download Button */}
          {filter == "details" && (
            <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4">
              <DownloadReportButton
                onContinue={handleContinueTaxStatementReport}
                onExcel={handleExcelTaxStatementReport}
                checkDisabled={isLoadingGraph === true}
                buttonText="Download Tax Statement"
                confirmTitle="Download Tax Statement"
                confirmMessage="You can download the statement in PDF or Excel format."
              />
              <DownloadReportButton
                onContinue={handleContinueHoldingReport}
                onExcel={handleExcelHoldingReport}
                checkDisabled={isLoadingGraph === true}
                buttonText="Download Holding Valuation Report"
                confirmTitle="Download Holding Valuation Report"
                confirmMessage="You can download the report in PDF or Excel format."
              />
              <DownloadReportButton
                onContinue={handleContinue}
                onExcel={handleExcel}
                checkDisabled={isLoadingGraph === true}
                buttonText="Download Factsheet"
                confirmTitle="Download Factsheet"
                confirmMessage="You can download the report in PDF or Excel format."
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InvestmentDetailsByCustomerID;
